webpackJsonp([1],{

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(555),
  /* scopeId */
  "data-v-25ca561d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wellcome_Trust_logo.9bc8d78.png";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/canSAR_logo_0913_alpha_500x326.bbfb70f.png";

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.200052b.png";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/targetvalidationtoolkit2.81a2285.png";

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_meta__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_analytics___default.a, {
  id: 'UA-103245797-1',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_meta___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PrbLanding__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PrbLanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PrbLanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PrbAbout__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PrbAbout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PrbAbout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PrbFaq__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PrbFaq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PrbFaq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PrbContact__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PrbContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PrbContact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PrbLimitations__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PrbLimitations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PrbLimitations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PrbTutorial__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PrbTutorial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_PrbTutorial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PrbDownload__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PrbDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_PrbDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PrbCompoundSynopsis__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PrbCompoundSynopsis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_PrbCompoundSynopsis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PrbCompoundsAll__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PrbCompoundsAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_PrbCompoundsAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PrbSingleCompoundSynopsis__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PrbSingleCompoundSynopsis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_PrbSingleCompoundSynopsis__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'prblanding',
    component: __WEBPACK_IMPORTED_MODULE_2__components_PrbLanding___default.a
  }, {
    path: '/about',
    name: 'prbabout',
    component: __WEBPACK_IMPORTED_MODULE_3__components_PrbAbout___default.a
  }, {
    path: '/contact',
    name: 'prbcontact',
    component: __WEBPACK_IMPORTED_MODULE_5__components_PrbContact___default.a
  }, {
    path: '/limitations',
    name: 'prblimitations',
    component: __WEBPACK_IMPORTED_MODULE_6__components_PrbLimitations___default.a
  }, {
    path: '/tutorial',
    name: 'prbtutorial',
    component: __WEBPACK_IMPORTED_MODULE_7__components_PrbTutorial___default.a
  }, {
    path: '/download',
    name: 'prbdownload',
    component: __WEBPACK_IMPORTED_MODULE_8__components_PrbDownload___default.a
  }, {
    path: '/faq',
    name: 'prbfaq',
    component: __WEBPACK_IMPORTED_MODULE_4__components_PrbFaq___default.a
  }, { path: '/:id',
    name: 'prbcompoundsynopsis',
    component: __WEBPACK_IMPORTED_MODULE_9__components_PrbCompoundSynopsis___default.a
  }, { path: '/:id/compounds',
    name: 'prbcompoundsall',
    component: __WEBPACK_IMPORTED_MODULE_10__components_PrbCompoundsAll___default.a
  }, { path: '/:id/:compound',
    name: 'prbsinglecompoundsynopsis',
    component: __WEBPACK_IMPORTED_MODULE_11__components_PrbSingleCompoundSynopsis___default.a
  }]
}));

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var urlG = "https://cansar.icr.ac.uk/";

var state = {
  termsVerified: false,
  searchResultsList: [],
  targetResultsList: [],
  probesResultsList: [],
  probesResultsListCustom: [],
  compoundResultsList: [],
  compound2ResultsList: [],
  probeGeneName: null,
  portalList: null,
  loading: false,
  urlG: urlG
};

var getters = {
  termsVerified: function termsVerified(state) {
    return state.termsVerified;
  },
  searchResultsList: function searchResultsList(state) {
    return state.searchResultsList;
  },
  targetResultsList: function targetResultsList(state) {
    return state.targetResultsList;
  },
  probesResultsList: function probesResultsList(state) {
    return state.probesResultsList;
  },
  probesResultsListCustom: function probesResultsListCustom(state) {
    return state.probesResultsListCustom;
  },
  compoundResultsList: function compoundResultsList(state) {
    return state.compoundResultsList;
  },
  compound2ResultsList: function compound2ResultsList(state) {
    return state.compound2ResultsList;
  },
  probeGeneName: function probeGeneName(state) {
    return state.probeGeneName;
  },
  portalList: function portalList(state) {
    return state.portalList;
  },
  loading: function loading(state) {
    return state.loading;
  }
};

var mutations = {
  VERIFY_TERMS: function VERIFY_TERMS(state) {
    state.termsVerified = true;
  },
  SET_SEARCH_LIST: function SET_SEARCH_LIST(state, _ref) {
    var data = _ref.data;

    var a = [];
    data.map(function (m, i) {
      a.push({
        name: m[0],
        uni: m[2],
        is_suitable_probe: m[3][0] === '0' ? 0 : m[3].substring(0, m[3].indexOf("|")),
        is_selectivity: m[4][0] === '0' ? 0 : m[4].substring(0, m[4].indexOf("|")),
        is_target_potency: m[5][0] === '0' ? 0 : m[5].substring(0, m[5].indexOf("|")),
        is_cell_potency: m[6][0] === '0' ? 0 : m[6].substring(0, m[6].indexOf("|")),
        is_sar: m[7][0] === '0' ? 0 : m[7].substring(0, m[7].indexOf("|")),
        is_inactive_analogs: m[8][0] === '0' ? 0 : m[8].substring(0, m[8].indexOf("|")),
        is_pains: m[9][0] === '0' ? 0 : m[9].substring(0, m[9].indexOf("|")),
        compounds: m[10],
        score: m[11]
      });
    });
    state.searchResultsList = a;
  },
  SET_TARGET_BY_ID: function SET_TARGET_BY_ID(state, _ref2) {
    var data = _ref2.data;

    var a = [];

    if (data) {

      data.map(function (m, i) {
        a.push({
          name: m[0],
          uni: m[2],
          is_suitable_probe: m[3][0] === '0' ? 0 : m[3].substring(0, m[3].indexOf("|")),
          is_selectivity: m[4][0] === '0' ? 0 : m[4].substring(0, m[4].indexOf("|")),
          is_target_potency: m[5][0] === '0' ? 0 : m[5].substring(0, m[5].indexOf("|")),
          is_cell_potency: m[6][0] === '0' ? 0 : m[6].substring(0, m[6].indexOf("|")),
          is_sar: m[7][0] === '0' ? 0 : m[7].substring(0, m[7].indexOf("|")),
          is_inactive_analogs: m[8][0] === '0' ? 0 : m[8].substring(0, m[8].indexOf("|")),
          is_pains: m[9][0] === '0' ? 0 : m[9].substring(0, m[9].indexOf("|")),
          compounds: m[10],
          score: m[11]
        });
      });
    }

    state.targetResultsList = a.length ? a[0] : null;
  },
  SET_TARGET_PROBES_BY_ID: function SET_TARGET_PROBES_BY_ID(state, _ref3) {
    var data = _ref3.data;

    if (data.data !== null) {
      state.probesResultsList = data.tabs_info.tab1;
      state.probeGeneName = data.gene_name;
      state.portalList = data.probe_portal || null;
    } else if (data.data === null) {
      state.probesResultsList = null;
      state.probeGeneName = null;
      state.portalList = null;
    }
  },
  SET_TARGET_PROBES_BY_ID_AND_CUSTOM_FILTERS: function SET_TARGET_PROBES_BY_ID_AND_CUSTOM_FILTERS(state, _ref4) {
    var data = _ref4.data;

    state.probesResultsListCustom = data.tabs_info.tab1;
  },
  SET_COMPOUND_BY_ID: function SET_COMPOUND_BY_ID(state, _ref5) {
    var data = _ref5.data;

    if (data && data.data && data.data_compound) {
      state.compoundResultsList = data;
      state.probeGeneName = data.gene_name;
    } else {
      state.compoundResultsList = null;
      state.probeGeneName = null;
    }
  },
  SET_COMPOUND2_BY_ID: function SET_COMPOUND2_BY_ID(state, _ref6) {
    var data = _ref6.data;

    if (!data) {
      state.compound2ResultsList = null;
    } else {
      state.compound2ResultsList = data;
    }
  },
  SET_LOADING: function SET_LOADING(state) {
    state.loading = true;
  },
  UNSET_LOADING: function UNSET_LOADING(state) {
    state.loading = false;
  }
};

var actions = {
  VERIFY_TERMS: function VERIFY_TERMS(_ref7) {
    var commit = _ref7.commit;

    commit('VERIFY_TERMS');
  },
  SET_LOADING: function SET_LOADING(_ref8) {
    var commit = _ref8.commit;

    commit('SET_LOADING');
  },
  UNSET_LOADING: function UNSET_LOADING(_ref9) {
    var commit = _ref9.commit;

    commit('UNSET_LOADING');
  },
  GET_SEARCH_RESULTS: function GET_SEARCH_RESULTS(_ref10, t) {
    var commit = _ref10.commit;


    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

      var url = urlG + "/shared/ajax/all_ajax_calls_in_one_place.php?cmd=get_table_data&key=" + t + "&query=protein_keyword_search";

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
        commit('SET_SEARCH_LIST', {
          data: response.data.data
        });
        resolve();
      }, function (err) {
        console.log(err);
      });
    });
  },
  GET_TARGET_RESULTS_BY_ID: function GET_TARGET_RESULTS_BY_ID(_ref11, t) {
    var commit = _ref11.commit;


    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

      var url = urlG + "/shared/ajax/all_ajax_calls_in_one_place.php?cmd=get_table_data&key=" + t + "&query=protein_keyword_search";

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {

        if (response.data.data.length === 1 && response.data.data[0][2] === t) {
          commit('SET_TARGET_BY_ID', {
            data: response.data.data
          });
        } else {
          commit('SET_TARGET_BY_ID', {
            data: null
          });
        }
        resolve();
      }, function (err) {
        console.log(err);
      });
    });
  },
  GET_TARGET_PROBES_RESULTS_BY_ID: function GET_TARGET_PROBES_RESULTS_BY_ID(_ref12, t) {
    var commit = _ref12.commit;


    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

      var url = urlG + "/api.php?action=get_chemprobes_info&uniprot=" + t;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {

        commit('SET_TARGET_PROBES_BY_ID', {
          data: response.data
        });
        resolve();
      }, function (err) {
        commit('SET_TARGET_PROBES_BY_ID', {
          data: {
            data: null
          }
        });
        resolve();
        console.log(err);
      });
    });
  },
  GET_TARGET_PROBES_RESULTS_BY_ID_AND_CUSTOM_FILTERS: function GET_TARGET_PROBES_RESULTS_BY_ID_AND_CUSTOM_FILTERS(_ref13, t) {
    var commit = _ref13.commit;


    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

      var url = urlG + "/api.php?action=get_chemprobes_info&uniprot=" + t.id + "&cell_potency=" + t.filters.cell_potency + "&target_potency=" + t.filters.target_potency + "&sar=" + t.filters.sar + "&selectivity=" + t.filters.selectivity + "&pains=" + t.filters.pains + "&inactive_analogs=" + t.filters.inactive_analogs;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {

        commit('SET_TARGET_PROBES_BY_ID_AND_CUSTOM_FILTERS', {
          data: response.data
        });
        resolve();
      }, function (err) {
        console.log(err);
      });
    });
  },
  GET_COMPOUND_RESULTS_BY_ID: function GET_COMPOUND_RESULTS_BY_ID(_ref14, t) {
    var commit = _ref14.commit;


    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

      var url = urlG + "/api.php?action=get_chemprobes_info&uniprot=" + t.id + "&compound_id=" + t.compound;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
        commit('SET_COMPOUND_BY_ID', {
          data: response.data
        });
        resolve();
      }, function (err) {
        commit('SET_COMPOUND_BY_ID', {
          data: null
        });
        resolve();
        console.log(err);
      });
    });
  },
  GET_COMPOUND2_RESULTS_BY_ID: function GET_COMPOUND2_RESULTS_BY_ID(_ref15, t) {
    var commit = _ref15.commit;


    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

      var url = urlG + "/api.php?action=get_compound_info&compound_id=" + t;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {

        commit('SET_COMPOUND2_BY_ID', {
          data: response.data
        });
        resolve();
      }, function (err) {

        commit('SET_COMPOUND2_BY_ID', {
          data: null
        });
        resolve();
        console.log(err);
      });
    });
  }

};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}));

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      snackBar: {
        snackbar: true,
        y: 'top',
        x: null,
        mode: '',
        text: 'Updated to ChEMBL 28'
      }
    };
  },
  beforeMount: function beforeMount() {
    if (__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get("prbTerms")) {
      this.$store.dispatch("VERIFY_TERMS");
    }
  },
  mounted: function mounted() {
    var that = this;

    setTimeout(function () {
      that.snackBar.snackbar = false;
    }, 12000);
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__);


var _components$computed$;







/* harmony default export */ __webpack_exports__["default"] = (_components$computed$ = {
  components: {
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default.a
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified']),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | About'
  },
  name: 'prbabout'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'data', function data() {
  return {
    termsDialog: true,
    search: null,
    e1: 1
  };
}), _components$computed$);

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrbLoading__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrbLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PrbLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prb_target_prb_target_top_PrbTargetTop__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prb_target_prb_target_top_PrbTargetTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__prb_target_prb_target_top_PrbTargetTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prb_target_prb_target_compounds_PrbTargetCompounds__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prb_target_prb_target_compounds_PrbTargetCompounds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__prb_target_prb_target_compounds_PrbTargetCompounds__);


var _metaInfo$components$;










/* harmony default export */ __webpack_exports__["default"] = (_metaInfo$components$ = {
  metaInfo: function metaInfo() {
    return {
      title: this.titleName || ' ',
      titleTemplate: 'Probe Miner | %s'
    };
  },

  components: {
    PrbLoading: __WEBPACK_IMPORTED_MODULE_2__PrbLoading___default.a,
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_3__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_4__prb_terms_PrbTerms___default.a,
    PrbTargetTop: __WEBPACK_IMPORTED_MODULE_6__prb_target_prb_target_top_PrbTargetTop___default.a,
    PrbTargetCompounds: __WEBPACK_IMPORTED_MODULE_7__prb_target_prb_target_compounds_PrbTargetCompounds___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter___default.a
  },
  data: function data() {
    return {
      errorPage: false,
      displayValues: [{ title: 'Global Score', name: 'global' }, { title: 'Selectivity', name: 'selectivity' }, { title: 'Target Potency', name: 'target_potency' }, { title: 'Cell Potency', name: 'cell_potency' }, { title: 'SAR', name: 'sar' }, { title: 'Inactive Analogs', name: 'inactive_analogs' }, { title: 'Pains', name: 'pains' }],
      distribution: {
        categories: null,
        values: null
      },
      titleName: '',
      target: null,
      probes: null,
      portalList: [],
      portalList20: [],
      portalListRest: [],
      unmapped: [],
      sorted20: null,
      drawer: false,
      sort: 'global',
      display: 'global',
      customFiltersFlag: false,
      filtersCustom: {
        selectivity: 1,
        target_potency: 1,
        sar: 1,
        cell_potency: 1,
        inactive_analogs: 1,
        pains: 1
      }

    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified', 'loading']),
  name: 'prbcompoundsynopsis'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_metaInfo$components$, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  },
  loading: {
    get: function get() {
      return this.$store.state.loading;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_metaInfo$components$, 'mounted', function mounted() {
  var that = this;

  that.portalList = [];
  that.portalList20 = [];
  that.portalListRest = [];

  that.$store.dispatch("SET_LOADING");

  this.$store.dispatch("GET_TARGET_RESULTS_BY_ID", this.$route.params.id).then(function (res) {

    that.target = that.$store.state.targetResultsList;

    if (that.target) {
      that.titleName = that.target.name;
      that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function (res) {
        that.probes = that.$store.state.probesResultsList;
        if (that.$store.state.portalList) {
          that.portalList20 = that.$store.state.portalList.in_top_20;
          that.portalListRest = that.$store.state.portalList.not_in_top_20;
          that.unmapped = that.$store.state.portalList.unmapped;

          that.portalList20.map(function (m, i) {
            that.portalList.push({ name: m, top: true });
          });

          that.portalListRest.map(function (m, i) {
            that.portalList.push({ name: m, top: false });
          });

          that.$store.dispatch("UNSET_LOADING");

          that.getFirst20(that.sort);
        } else {
          that.errorPage = true;
          that.$store.dispatch("UNSET_LOADING");
        }
      });
    } else {
      that.errorPage = true;
      that.$store.dispatch("UNSET_LOADING");
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_metaInfo$components$, 'methods', {
  goToAll: function goToAll() {
    this.$router.push('/' + this.$route.params.id + '/compounds');
  },
  getFirst20: function getFirst20(sort) {

    this.$store.dispatch("SET_LOADING");

    var that = this;

    var sorted20KeysBySort = that.probes.top20[sort];
    var sorted20 = [];

    sorted20KeysBySort.map(function (key, i) {
      sorted20.push(that.probes.metadata[key]);
    });

    sorted20.map(function (m, i) {
      m['idc'] = sorted20KeysBySort[i];
      m['namec'] = m.name;
    });

    that.sorted20 = sorted20;
    that.distribution = that.probes.distributions[that.display];

    this.$store.dispatch("UNSET_LOADING");
  },
  changeSort: function changeSort(name) {
    this.sort = name;

    this.$store.dispatch("SET_LOADING");

    var that = this;

    var sorted20KeysBySort = that.probes.top20[name];
    var sorted20 = [];

    sorted20KeysBySort.map(function (key, i) {
      sorted20.push(that.probes.metadata[key]);
    });

    sorted20.map(function (m, i) {
      m['idc'] = sorted20KeysBySort[i];
      m['namec'] = m.name;
    });

    that.sorted20 = sorted20;

    this.$store.dispatch("UNSET_LOADING");
  },
  changeCustom: function changeCustom() {

    var that = this;

    var m = {
      id: that.$route.params.id,
      filters: that.filtersCustom
    };

    that.$store.dispatch("SET_LOADING");

    that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID_AND_CUSTOM_FILTERS", m).then(function (res) {
      that.probes = that.$store.state.probesResultsListCustom;

      var sorted20KeysBySort = that.probes.top20[that.sort];
      var sorted20 = [];

      sorted20KeysBySort.map(function (key, i) {
        sorted20.push(that.probes.metadata[key]);
      });

      sorted20.map(function (m, i) {
        m['idc'] = sorted20KeysBySort[i];
        m['namec'] = m.name;
      });

      that.sorted20 = sorted20;

      that.distribution = that.probes.distributions[that.display];

      that.$store.dispatch("UNSET_LOADING");
    });
  },
  changeEnableWeights: function changeEnableWeights(newValue) {
    var that = this;

    if (newValue) {
      that.sort = 'global';
      that.display = 'global';
      that.setDefaultWeights();
      that.changeSort(that.sort);
      that.changeCustom();
    } else {

      that.sort = 'global';
      that.display = 'global';
      that.customFiltersFlag = false;

      this.$store.dispatch("SET_LOADING");

      that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function (res) {
        that.probes = that.$store.state.probesResultsList;

        that.getFirst20(that.sort);
        that.$store.dispatch("UNSET_LOADING");
      });
    }
  },
  setDefaultWeights: function setDefaultWeights() {
    this.filtersCustom = { 'selectivity': 8, 'target_potency': 4, 'cell_potency': 2, 'inactive_analogs': 1, 'pains': 1, 'sar': 1 };
  },
  changeDisplay: function changeDisplay(name) {
    var that = this;

    this.display = name;

    that.distribution = that.probes.distributions[that.display];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_metaInfo$components$, 'watch', {
  '$route': function $route(to, from) {
    console.log(to, from);
    var that = this;

    that.portalList = [];
    that.portalList20 = [];
    that.portalListRest = [];
    that.errorPage = false;
    that.sort = 'global';
    that.display = 'global';
    that.customFiltersFlag = false;

    this.$store.dispatch("SET_LOADING");

    this.$store.dispatch("GET_TARGET_RESULTS_BY_ID", this.$route.params.id).then(function (res) {
      that.target = that.$store.state.targetResultsList;

      if (that.target) {
        that.titleName = that.target.name;
        that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function (res) {
          that.probes = that.$store.state.probesResultsList;

          if (that.$store.state.portalList) {
            that.portalList20 = that.$store.state.portalList.in_top_20;
            that.portalListRest = that.$store.state.portalList.not_in_top_20;
            that.unmapped = that.$store.state.portalList.unmapped;

            that.portalList20.map(function (m, i) {
              that.portalList.push({ name: m, top: true });
            });

            that.portalListRest.map(function (m, i) {
              that.portalList.push({ name: m, top: false });
            });

            that.$store.dispatch("UNSET_LOADING");

            that.getFirst20(that.sort);
          } else {
            that.errorPage = true;
            that.$store.dispatch("UNSET_LOADING");
          }
        });
      } else {
        that.errorPage = true;
        that.$store.dispatch("UNSET_LOADING");
      }
    });
  }
}), _metaInfo$components$);

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrbLoading__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrbLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PrbLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__prb_footer_PrbFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_Features__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_Features___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__constants_Features__);




var _components$metaInfo$;









/* harmony default export */ __webpack_exports__["default"] = (_components$metaInfo$ = {
  components: {
    PrbLoading: __WEBPACK_IMPORTED_MODULE_4__PrbLoading___default.a,
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_5__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_6__prb_terms_PrbTerms___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_7__prb_footer_PrbFooter___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: this.titleName || ' ',
      titleTemplate: 'Probe Miner | %s | List Probes'
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['termsVerified', 'loading']),
  name: 'prbcompoundsynopsis'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  },
  loading: {
    get: function get() {
      return this.$store.state.loading;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'beforeMount', function beforeMount() {
  this.tableFeatures = __WEBPACK_IMPORTED_MODULE_8__constants_Features__["FEATURES"];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'data', function data() {
  return {
    apiUrl: "https://cansar.icr.ac.uk/",
    errorPage: false,
    probes: null,
    titleName: '',
    pagination: {
      rowsPerPage: 10
    },
    tableSearch: '',
    tableHeaders: [{
      text: 'Compound',
      align: 'left',
      sortable: false,
      value: 'image',
      tooltip: 'image'
    }, {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'nameProbe',
      tooltip: 'Name of target'
    }, {
      text: 'Features',
      align: 'left',
      sortable: false,
      value: 'is_suitable_probe',
      tooltip: 'Toggle for more information about the icons'
    }, {
      text: 'Global Score',
      align: 'left',
      sortable: true,
      value: 'global',
      tooltip: 'Global Score'
    }, {
      text: 'ChemicalProbes.org Rating',
      align: 'left',
      sortable: true,
      value: 'chemical_probes_portal_rating',
      tooltip: 'Chemical Probes Portal Rating'
    }]
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'methods', {
  downloadCsv: function downloadCsv(data) {
    this.$store.dispatch("SET_LOADING");

    var JSONData = data;
    var ReportTitle = this.$route.params.id + '_ChemicalProbes';
    var ShowLabel = true;

    var arrData = (typeof JSONData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(JSONData)) != 'object' ? JSON.parse(JSONData) : JSONData;

    var CSV = '';


    CSV += ReportTitle + '\r\n\n';

    if (ShowLabel) {
      var row = "";

      for (var index in arrData[0]) {
        row += index + ',';
      }

      row = row.slice(0, -1);

      CSV += row + '\r\n';
    }

    for (var i = 0; i < arrData.length; i++) {
      var row = "";

      for (var index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }

      row.slice(0, row.length - 1);

      CSV += row + '\r\n';
    }

    if (CSV == '') {
      alert("Invalid data");
      return;
    }

    var fileName = "Report_";

    fileName += ReportTitle.replace(/ /g, "_");

    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    var link = document.createElement("a");
    link.id = "copy-link";
    link.href = uri;

    document.body.appendChild(link);

    document.getElementById("copy-link").style.visibility = "hidden";

    document.getElementById("copy-link").download = fileName + ".csv";

    document.body.appendChild(link);
    document.getElementById("copy-link").click();

    document.body.removeChild(link);

    this.$store.dispatch("UNSET_LOADING");
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'name', 'prbcompoundsall'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'mounted', function mounted() {
  var that = this;

  this.$store.dispatch("SET_LOADING");

  var reg = new RegExp('^\\d+$');

  that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function (res) {

    if (that.$store.state.probesResultsList) {
      var probes = that.$store.state.probesResultsList.metadata;

      that.titleName = that.$store.state.probeGeneName;

      var s = [];

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(probes).map(function (m, i) {
        s.push(probes[m]);
        s[i]['nameProbe'] = reg.test(probes[m].name) ? 'canSAR' + probes[m].name : probes[m].name;
        s[i]['id'] = m;
        s[i]['chemical_probes_portal_rating'] = s[i].chemical_probes_portal !== undefined ? parseFloat(s[i].chemical_probes_portal.rating_cell).toFixed(2) : '-';
        s[i]['chemical_probes_portal_link'] = s[i].chemical_probes_portal !== undefined ? 'http://www.chemicalprobes.org/' + s[i].name : null;
        delete s[i]['chemical_probes_portal'];
        delete s[i]['name'];
      });

      that.probes = s;
      that.$store.dispatch("UNSET_LOADING");
    } else {
      that.errorPage = true;
      that.$store.dispatch("UNSET_LOADING");
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'watch', {
  '$route': function $route(to, from) {
    var that = this;

    that.errorPage = false;

    this.$store.dispatch("SET_LOADING");

    var reg = new RegExp('^\\d+$');

    that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function (res) {

      if (that.$store.state.probesResultsList) {
        var probes = that.$store.state.probesResultsList.metadata;

        that.titleName = that.$store.state.probeGeneName;

        var s = [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(probes).map(function (m, i) {
          s.push(probes[m]);
          s[i]['nameProbe'] = reg.test(probes[m].name) ? 'canSAR' + probes[m].name : probes[m].name;
          s[i]['id'] = m;
          s[i]['chemical_probes_portal_rating'] = s[i].chemical_probes_portal !== undefined ? parseFloat(s[i].chemical_probes_portal.rating_cell).toFixed(2) : '';
          s[i]['chemical_probes_portal_link'] = s[i].chemical_probes_portal !== undefined ? 'http://www.chemicalprobes.org/' + s[i].name : null;
          delete s[i]['chemical_probes_portal'];
          delete s[i]['name'];
        });

        that.probes = s;
        that.$store.dispatch("UNSET_LOADING");
      } else {
        that.errorPage = true;
        that.$store.dispatch("UNSET_LOADING");
      }
    });
  }
}), _components$metaInfo$);

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__);


var _components$computed$;







/* harmony default export */ __webpack_exports__["default"] = (_components$computed$ = {
  components: {
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default.a
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified']),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Contact'
  },
  name: 'prbcontact'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'data', function data() {
  return {
    termsDialog: true,
    search: null,
    e1: 1
  };
}), _components$computed$);

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__);


var _components$computed$;







/* harmony default export */ __webpack_exports__["default"] = (_components$computed$ = {
  components: {
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default.a
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified']),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Download'
  },
  name: 'prbdownload'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'data', function data() {
  return {
    apiUrl: "https://cansar.icr.ac.uk/",
    termsDialog: true,
    search: null,
    e1: 1
  };
}), _components$computed$);

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__);


var _components$metaInfo$;







/* harmony default export */ __webpack_exports__["default"] = (_components$metaInfo$ = {
  components: {
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default.a
  },
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | FAQ'
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified']),
  name: 'prbfaq'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$metaInfo$, 'data', function data() {
  return {
    termsDialog: true,
    search: null,
    e1: 1,
    apiUrl: "https://cansar.icr.ac.uk/"
  };
}), _components$metaInfo$);

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_stepper_PrbStepper__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_stepper_PrbStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_stepper_PrbStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter__);










/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Home'
  },
  components: {
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default.a,
    PrbStepper: __WEBPACK_IMPORTED_MODULE_4__prb_stepper_PrbStepper___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter___default.a
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified']),
  name: 'prblanding'
}, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  }
}));

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__);


var _components$computed$;







/* harmony default export */ __webpack_exports__["default"] = (_components$computed$ = {
  components: {
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default.a
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified']),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Limitations'
  },
  name: 'prblimitations'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'data', function data() {
  return {
    apiUrl: "https://cansar.icr.ac.uk/",
    termsDialog: true,
    search: null,
    e1: 1
  };
}), _components$computed$);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrbLoading__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrbLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PrbLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prb_compound_prb_compound_top_PrbCompoundTop__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prb_compound_prb_compound_top_PrbCompoundTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__prb_compound_prb_compound_top_PrbCompoundTop__);


var _metaInfo$computed$co;









/* harmony default export */ __webpack_exports__["default"] = (_metaInfo$computed$co = {
  metaInfo: function metaInfo() {
    return {
      title: this.titleName || ' ',
      titleTemplate: 'Probe Miner | %s'
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified', 'loading']),
  components: {
    PrbLoading: __WEBPACK_IMPORTED_MODULE_2__PrbLoading___default.a,
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_3__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_4__prb_terms_PrbTerms___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_5__prb_footer_PrbFooter___default.a,
    PrbCompoundTop: __WEBPACK_IMPORTED_MODULE_6__prb_compound_prb_compound_top_PrbCompoundTop___default.a
  },
  name: 'prbsinglecompoundsynopsis',
  data: function data() {
    return {
      errorPage: false,
      compound: null,
      compound2: null,
      nameC: '',
      nameT: '',
      titleName: ''
    };
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_metaInfo$computed$co, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  },
  loading: {
    get: function get() {
      return this.$store.state.loading;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_metaInfo$computed$co, 'mounted', function mounted() {
  var that = this;

  var t = { id: that.$route.params.id, compound: that.$route.params.compound };

  that.$store.dispatch("SET_LOADING");

  this.$store.dispatch("GET_COMPOUND_RESULTS_BY_ID", t).then(function (res) {

    that.compound = that.$store.state.compoundResultsList;
    that.nameT = that.$store.state.probeGeneName;

    if (!that.nameT || !that.compound) {
      that.errorPage = true;
      that.$store.dispatch("UNSET_LOADING");
    } else {
      that.$store.dispatch("GET_COMPOUND2_RESULTS_BY_ID", that.$route.params.compound).then(function (res) {
        that.compound2 = that.$store.state.compound2ResultsList;

        if (that.compound2) {
          that.nameC = 'Compound: ' + that.compound2.PREFERRED_NAME;
          that.titleName = that.nameT + ' | ' + that.compound2.PREFERRED_NAME;
          that.$store.dispatch("UNSET_LOADING");
        } else {
          that.errorPage = true;
          that.$store.dispatch("UNSET_LOADING");
        }
      });
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_metaInfo$computed$co, 'watch', {
  '$route': function $route(to, from) {

    var that = this;

    that.errorPage = false;

    that.$store.dispatch("SET_LOADING");

    var t = { id: that.$route.params.id, compound: that.$route.params.compound };

    this.$store.dispatch("GET_COMPOUND_RESULTS_BY_ID", t).then(function (res) {
      that.compound = that.$store.state.compoundResultsList;
      that.nameT = that.$store.state.probeGeneName;
      if (!that.nameT || !that.compound) {
        that.errorPage = true;
        that.$store.dispatch("UNSET_LOADING");
      } else {
        that.$store.dispatch("GET_COMPOUND2_RESULTS_BY_ID", that.$route.params.compound).then(function (res) {
          that.compound2 = that.$store.state.compound2ResultsList;
          if (that.compound2) {
            that.nameC = 'Compound: ' + that.compound2.PREFERRED_NAME;
            that.titleName = that.nameT + ' | ' + that.compound2.PREFERRED_NAME;
            that.$store.dispatch("UNSET_LOADING");
          } else {
            that.errorPage = true;
            that.$store.dispatch("UNSET_LOADING");
          }
        });
      }
    });
  }
}), _metaInfo$computed$co);

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter__);


var _components$computed$;







/* harmony default export */ __webpack_exports__["default"] = (_components$computed$ = {
  components: {
    PrbToolbar: __WEBPACK_IMPORTED_MODULE_2__prb_toolbar_PrbToolbar___default.a,
    PrbTerms: __WEBPACK_IMPORTED_MODULE_3__prb_terms_PrbTerms___default.a,
    PrbFooter: __WEBPACK_IMPORTED_MODULE_4__prb_footer_PrbFooter___default.a
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['termsVerified']),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Tutorial'
  },
  name: 'prbtutorial'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'computed', {
  terms: {
    get: function get() {
      return this.$store.state.termsVerified;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$computed$, 'data', function data() {
  return {
    termsDialog: true,
    search: null,
    e1: 1
  };
}), _components$computed$);

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tippy_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tippy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tippy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_Features__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_Features___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__constants_Features__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highcharts_highcharts_more__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highcharts_highcharts_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_highcharts_highcharts_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_features_PrbFeatures__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prb_features_PrbFeatures___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__prb_features_PrbFeatures__);








var Highcharts = __webpack_require__(195);
__webpack_require__(196)(Highcharts);
__webpack_require__(197)(Highcharts);
__webpack_require__(516)(Highcharts);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['compound', 'compound2'],
  components: { PrbFeatures: __WEBPACK_IMPORTED_MODULE_5__prb_features_PrbFeatures___default.a },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['loading']),
  beforeMount: function beforeMount() {
    this.features = __WEBPACK_IMPORTED_MODULE_3__constants_Features__["FEATURES"];
  },
  data: function data() {
    return {
      apiUrl: "https://cansar.icr.ac.uk/"
    };
  },
  mounted: function mounted() {
    this.$store.dispatch("SET_LOADING");

    __WEBPACK_IMPORTED_MODULE_2_tippy_js___default()('#features-tooltip', {
      html: '#icons-details',
      duration: 1000,
      arrow: true,
      trigger: 'mouseenter'
    });

    this.createSpider();

    var categories = [];
    var values = [];

    var uniprots = this.compound.data_uniprots.sort(function (a, b) {
      var keyA = a.y,
          keyB = b.y;

      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });

    uniprots.map(function (m, i) {
      categories.push(m.name);
      values.push(m.y);
    });

    this.createBar(categories, values);

    this.$store.dispatch("UNSET_LOADING");
  },

  methods: {
    createSpider: function createSpider() {

      var that = this;

      that.spiderChart = Highcharts.chart('spider', {

        chart: {
          polar: true,
          type: 'line',
          renderTo: 'spider',
          style: {
            fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
          }
        },

        title: {
          text: '',
          x: -80
        },

        pane: {
          size: '80%'
        },

        xAxis: {
          categories: ['PAINS-free', 'Selectivity', 'Target Potency', 'Cell Potency', 'SAR', 'Inactive Analogs'],
          tickmarkPlacement: 'on',
          lineWidth: 0,
          padding: 0,
          labels: {
            style: {
              color: 'rgba(0,0,0,.7)'
            }
          }
        },

        yAxis: {
          gridLineInterpolation: 'polygon',
          lineWidth: 0,
          min: 0,
          tickPositioner: function tickPositioner(min, max) {
            return [min, max];
          }
        },

        tooltip: {
          pointFormat: "Value: {point.y:.2f}"
        },

        legend: {
          align: 'right',
          verticalAlign: 'top',
          y: 70,
          layout: 'vertical'
        },

        series: [{
          name: 'Values',
          showInLegend: false,
          color: '#4DB6AC',
          data: [that.compound.data_compound.pains, that.compound.data_compound.selectivity, that.compound.data_compound.target_potency, that.compound.data_compound.cell_potency, that.compound.data_compound.sar, that.compound.data_compound.is_inactive_analogs],
          pointPlacement: 'on'
        }]
      });
    },
    createBar: function createBar(categories, values) {
      var that = this;

      that.barChart = Highcharts.chart('bar-profile', {
        chart: {
          type: 'column',
          renderTo: 'bar-profile',
          style: {
            fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
          }
        },
        title: {
          text: 'Protein Affinity Profile'
        },
        navigator: {
          enabled: true,
          xAxis: {
            labels: {
              formatter: function formatter() {
                return null;
              }
            }
          },
          series: {
            type: 'areaspline',
            color: '#4DB6AC',
            fillOpacity: 0.1,
            dataGrouping: {
              smoothed: true
            },
            lineWidth: 0,
            marker: {
              enabled: false
            }
          }
        },
        xAxis: {

          categories: categories,
          xAxis: { labels: { formatter: function formatter() {
                return this.value;
              } } }
        },
        yAxis: {
          title: {
            text: 'pActivity'
          },
          min: 0
        },
        plotOptions: {
          spline: {
            marker: {
              enabled: true
            }
          }
        },
        series: [{
          name: 'pActivity',
          data: values,
          showInLegend: false,
          color: '#4DB6AC',
          pointPadding: 0.01,
          groupPadding: 0
        }]
      });
    }
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['compound', 'features']
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tippy_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tippy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tippy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_Features__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_Features___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__constants_Features__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['disable'],
  beforeMount: function beforeMount() {
    this.tableFeatures = __WEBPACK_IMPORTED_MODULE_3__constants_Features__["FEATURES"];
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_tippy_js___default()('#features-tooltip', {
      html: '#icons-details',
      duration: 1000,
      arrow: true,
      trigger: 'click'
    });
  },
  data: function data() {
    var _this = this;

    return {
      search: null,
      e1: 1,
      pagination: {},
      emptyRule: true,
      evaluation: null,
      tableFeatures: null,
      tableSearch: '',
      tableHeaders: [{
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
        tooltip: 'Name of target'
      }, {
        text: 'Features',
        align: 'left',
        sortable: false,
        value: 'is_suitable_probe',
        tooltip: 'Toggle for more information about the icons'
      }, {
        text: 'Compounds',
        align: 'left',
        sortable: true,
        value: 'compounds',
        tooltip: 'Number of compounds'
      }, {
        text: 'Info Richness Score',
        align: 'left',
        sortable: true,
        value: 'score',
        tooltip: 'Information Richness Score'
      }],
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        empty: function empty() {
          return !!_this.emptyRule || 'No results found';
        }
      }
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['searchResultsList', 'loading']),
  methods: {
    getSearchResults: function getSearchResults() {
      var that = this;

      that.$store.dispatch("SET_LOADING");

      this.$store.dispatch("GET_SEARCH_RESULTS", that.search).then(function () {
        if (that.searchResultsList.length) {
          that.emptyRule = true;
          that.e1 = 2;
        } else {
          that.emptyRule = false;
        }
        that.$store.dispatch("UNSET_LOADING");
      });
    },
    redirectToProbes: function redirectToProbes(id) {
      this.$router.push('/' + id);
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tippy_js_dist_tippy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tippy_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tippy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tippy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_siema__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_siema___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_siema__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_highcharts_highcharts_more__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_highcharts_highcharts_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_highcharts_highcharts_more__);









var Highcharts = __webpack_require__(195);
__webpack_require__(196)(Highcharts);
__webpack_require__(197)(Highcharts);


__WEBPACK_IMPORTED_MODULE_5_highcharts_highcharts_more___default()(Highcharts);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['sorted20', 'all', 'settings', 'distribution'],
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_4_vue_star_rating___default.a
  },
  data: function data() {
    return {
      apiUrl: "https://cansar.icr.ac.uk/",
      mappingValues: {
        'global': 'Global',
        'selectivity': 'Selectivity',
        'target_potency': 'Target Potency',
        'cell_potency': 'Cell Potency',
        'sar': 'SAR',
        'inactive_analogs': 'Inactive Analogs',
        'pains': 'PAINS'
      },
      spiderChart: [],
      selected: null,
      mySiema: null,
      counter: 0,
      counterPrc: 0,
      loadingLocal: false,
      categories1: [],
      categories2: [],
      doneloading: true
    };
  },
  mounted: function mounted() {

    __WEBPACK_IMPORTED_MODULE_2_tippy_js___default()('#radar-tooltip', {
      html: '#radar-details',
      duration: 1000,
      arrow: true,
      trigger: 'mouseenter'
    });

    var categories = [];
    var values = [];

    var that = this;

    this.sorted20.map(function (m) {
      categories.push(m.namec);
      values.push(m[that.settings.display]);
    });

    this.categories1 = categories;

    this.renderChart(categories, values);
    this.renderCarousel();

    var imgs = document.querySelectorAll(".image-carousel"),
        len = imgs.length;

    [].forEach.call(imgs, function (img) {
      img.addEventListener('load', incrementCounter, false);
    });

    function incrementCounter() {
      that.counter = that.counter + 1;
      that.counterPrc = that.counter * 100 / that.sorted20.length;
    }

    var dTemp = this.distribution;

    var cDis = [],
        vDis = [];

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dTemp).map(function (m, i) {
      cDis.push(m);
      vDis.push(dTemp[m]);
    });

    this.renderDistribution(cDis, vDis);
  },

  watch: {
    counter: function counter(newValue) {
      if (newValue < this.sorted20.length) {
        this.doneloading = false;
      } else {
        this.doneloading = true;
      }
    },
    selected: function selected(newValue) {

      var that = this;

      that.barChart.series[0].data.map(function (m, i) {
        var point = that.barChart.series[0].data[i];

        if (newValue.namec === m.category) {
          if (newValue['chemical_probes_portal']) {
            point.update({
              color: "rgba(27, 73, 101, 1)"
            });
          } else {
            point.update({
              color: "#4DB6AC"
            });
          }
          that.mySiema.goTo(i);
        } else {
          if (newValue.namec !== that.sorted20[i].namec && that.sorted20[i].namec === m.category) {

            if (that.sorted20[i]['chemical_probes_portal']) {
              point.update({
                color: "rgba(27, 73, 101, 0.3)"
              });
            } else {
              point.update({
                color: "rgba(77, 182, 172, 0.3)"
              });
            }
          }
        }
      });
    },
    settings: function settings(newValue, oldValue) {

      var categories = [];
      var values = [];

      var that = this;

      if (that.barChart) {
        that.barChart.destroy();
        that.barChart = null;
        that.mySiema.destroy(true);
        this.sorted20.map(function (m, i) {
          if (that.spiderChart[i] !== undefined) {
            that.spiderChart[i].destroy();
          }
        });
      }

      this.sorted20.map(function (m) {
        categories.push(m.namec);
        values.push(m[that.settings.display]);
      });

      if (oldValue.sort !== newValue.sort) {
        that.counter = that.sorted20.length - that.diffIndex(that.categories1, categories);
        that.counterPrc = that.counter * 100 / that.sorted20.length;
        that.categories1 = categories;
        if (that.counter !== that.sorted20.length) {
          that.doneloading = false;
        }
      }

      this.renderChart(categories, values);

      this.mySiema.init();

      that.barChart.series[0].data.map(function (m, i) {

        var point = that.barChart.series[0].data[i];

        if (!i) {
          if (that.sorted20[i].namec === m.category) {
            if (that.sorted20[i]['chemical_probes_portal']) {
              point.update({
                color: "rgba(27, 73, 101, 1)"
              });
            } else {
              point.update({
                color: "#4DB6AC"
              });
            }
            that.mySiema.goTo(i);
          }
        } else {

          if (that.sorted20[i]['chemical_probes_portal']) {
            point.update({
              color: "rgba(27, 73, 101, 0.3)"
            });
          } else {
            point.update({
              color: "rgba(77, 182, 172, 0.3)"
            });
          }
        }
      });
    },
    distribution: function distribution(newValue) {

      var that = this;

      that.distributionChart.destroy();

      var dTemp = this.distribution;

      var cDis = [],
          vDis = [];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dTemp).map(function (m, i) {
        cDis.push(m);
        vDis.push(dTemp[m]);
      });
      this.renderDistribution(cDis, vDis);
    }
  },
  methods: {
    diffIndex: function diffIndex(arr1, arr2) {
      var diff = [];

      arr1.map(function (m, i) {
        if (m !== arr2[i]) {
          diff.push(i);
        }
      });

      return diff.length;
    },
    redirectToCompound: function redirectToCompound(compound) {
      this.$router.push('/' + this.$route.params.id + '/' + compound);
    },
    renderChart: function renderChart(categories, values) {

      var that = this;

      this.barChart = Highcharts.chart('container', {
        chart: {
          type: 'column',
          style: {
            fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
          }
        },
        title: {
          text: 'Top ' + this.sorted20.length + ' Rated Chemical Probes<br/> Sort By: <b>' + this.mappingValues[this.settings.sort] + ' Score </b><br/>Display value: <b>' + this.mappingValues[this.settings.display] + ' Score</b>',
          userHTML: true
        },
        xAxis: {
          categories: categories,
          title: {
            text: 'Chemical Probes'
          }
        },
        yAxis: {
          title: {
            text: this.mappingValues[this.settings.display] + ' Score'
          }
        },
        tooltip: {
          pointFormat: "Value: {point.y:.2f}"
        },
        series: [{
          name: 'Score',
          data: values,
          cursor: 'pointer',
          showInLegend: false,
          pointPadding: 0.03,
          groupPadding: 0,
          width: 30,
          point: {
            events: {
              click: function click() {
                that.selected = that.sorted20[this.index];
              }
            }
          }
        }]
      });
    },
    renderDistribution: function renderDistribution(categories, values) {

      var that = this;

      this.distributionChart = Highcharts.chart('distribution-chart', {
        chart: {
          type: 'column',
          style: {
            fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
          }
        },
        title: {
          text: 'Distribution' + '<br/>Display value: <b>' + this.mappingValues[this.settings.display] + ' Score</b>',
          userHTML: true
        },
        xAxis: {
          categories: categories
        },
        yAxis: {
          title: {
            text: 'Frequency'
          }
        },
        tooltip: {
          shared: true,
          formatter: function formatter() {
            return this.x + ': ' + '<b>' + this.y + ' compounds  </b>';
          }
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.5
          }
        },
        series: [{
          color: '#4DB6AC',
          pointPadding: 0,
          groupPadding: 0,
          name: 'Score',
          data: values
        }]
      });
    },
    renderCarousel: function renderCarousel() {
      var that = this;

      that.mySiema = new __WEBPACK_IMPORTED_MODULE_3_siema___default.a({
        onInit: printSlideIndex,
        onChange: printSlideIndex
      });

      document.querySelector('.prev').addEventListener('click', function () {
        return that.mySiema.prev();
      });
      document.querySelector('.next').addEventListener('click', function () {
        return that.mySiema.next();
      });

      function printSlideIndex() {

        that.selected = that.sorted20[this.currentSlide];

        var s = that.sorted20[this.currentSlide];

        that.spiderChart[this.currenSlide] = Highcharts.chart('spider-' + this.currentSlide, {

          chart: {
            polar: true,
            type: 'line',
            style: {
              fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
            }
          },

          title: {
            text: '',
            x: -80
          },

          pane: {
            size: '70%'
          },

          xAxis: {
            categories: ['PAINS-free', 'Selectivity', 'Target Potency', 'Cell Potency', 'SAR', 'Inactive Analogs'],
            tickmarkPlacement: 'on',
            lineWidth: 0,
            padding: 0,
            labels: {
              style: {
                color: 'rgba(0,0,0,.7)'
              }
            }
          },

          yAxis: {
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0,
            tickPositioner: function tickPositioner(min, max) {
              return [min, max];
            }
          },

          tooltip: {
            shared: true,
            pointFormat: "Value: {point.y:.2f}"
          },

          legend: {
            align: 'right',
            verticalAlign: 'top',
            y: 70,
            layout: 'vertical'
          },

          series: [{
            name: 'Values',
            showInLegend: false,
            color: '#4DB6AC',
            data: [s.pains, s.selectivity, s.target_potency, s.cell_potency, s.sar, s.is_inactive_analogs],
            pointPlacement: 'on'
          }]
        });
      }
    }
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tippy_js_dist_tippy_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tippy_js_dist_tippy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tippy_js_dist_tippy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tippy_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tippy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tippy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_Features__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_Features___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__constants_Features__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_characterisation_PrbCharacterisation__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prb_characterisation_PrbCharacterisation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prb_characterisation_PrbCharacterisation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_features_PrbFeatures__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prb_features_PrbFeatures___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prb_features_PrbFeatures__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['target'],
  components: { PrbCharacterisation: __WEBPACK_IMPORTED_MODULE_3__prb_characterisation_PrbCharacterisation___default.a, PrbFeatures: __WEBPACK_IMPORTED_MODULE_4__prb_features_PrbFeatures___default.a },
  beforeMount: function beforeMount() {
    this.features = __WEBPACK_IMPORTED_MODULE_2__constants_Features__["FEATURES"];
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_tippy_js___default()('#features-tooltip', {
      html: '#icons-details',
      duration: 1000,
      arrow: true,
      trigger: 'click'
    });
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['score'],
  methods: {
    getColorPct: function getColorPct(value) {
      var pct = parseInt(value);

      if (pct <= 24) {
        return 'red';
      } else if (pct > 24 && pct <= 50) {
        return 'orange';
      } else if (pct > 50 && pct <= 75) {
        return 'light-green';
      } else if (pct > 57) {
        return 'green';
      }
    },
    getColorPctHex: function getColorPctHex(value) {
      var pct = parseInt(value);

      if (pct <= 24) {
        return '#F44336';
      } else if (pct > 24 && pct <= 50) {
        return '#FF9800';
      } else if (pct > 50 && pct <= 75) {
        return '#8BC34A';
      } else if (pct > 57) {
        return '#4CAF50';
      }
    }
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['target', 'features']
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['termsDialog'],
  methods: {
    dialogRead: function dialogRead() {
      __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set("prbTerms", true);
      this.$store.dispatch("VERIFY_TERMS");
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['disable']
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FEATURES", function() { return FEATURES; });

var FEATURES = {
  is_suitable_probe: {
    textValid: "The target has chemical probes that meet the minimum quality criteria",
    textInvalid: "The target has not a chemical probe that meets the minimum quality criteria",
    textValidCompound: "The compound meets the minimum quality criteria",
    textInvalidCompound: "The compound does not meet the minimum quality criteria",
    imageValid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/MINQUALITY-ON.png",
    imageInvalid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/MINQUALITY-OFF.png"
  },
  is_selectivity: {
    textValid: "The target has chemical probes that are 10-fold selective against any other protein",
    textInvalid: "The target has not chemical probes that are 10-fold selective against any other protein",
    textValidCompound: "The compound is 10-fold selective against any other protein",
    textInvalidCompound: "The compound is not 10-fold selective against any other protein",
    imageValid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/SELECTIVE-ON.png",
    imageInvalid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/SELECTIVE-OFF.png"
  },
  is_target_potency: {
    textValid: "The target has chemical probes that are potent (<100 nM)",
    textInvalid: "The target has not chemical probes that are potent (<100 nM)",
    textValidCompound: "The compound is potent (<100 nM)",
    textInvalidCompound: "The compound is not potent (<100 nM)",
    imageValid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/BIOCHEMPOTENT-ON.png",
    imageInvalid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/BIOCHEMPOTENT-OFF.png"
  },
  is_cell_potency: {
    textValid: "The target has chemical probes that are cell-active (<10 uM)",
    textInvalid: "The target has not chemical probes that are cell-active (<10 uM)",
    textValidCompound: "The compound is cell-active (<10 uM)",
    textInvalidCompound: "The compound is not cell-active (<10 uM)",
    imageValid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/CELLACTIVE-ON.png",
    imageInvalid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/CELLACTIVE-OFF.png"
  },
  is_sar: {
    textValid: "The target has chemical probes with Structure-Activity Relationships (SAR)",
    textInvalid: "The target has not chemical probes with Structure-Activity Relationships (SAR)",
    textValidCompound: "The compound has Structure-Activity Relationships (SAR)",
    textInvalidCompound: "The compound has not Structure-Activity Relationships (SAR)",
    imageValid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/SAR-ON.png",
    imageInvalid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/SAR-OFF.png"
  },
  is_inactive_analogs: {
    textValid: "The target has chemical probes which have inactive analogs",
    textInvalid: "The target has not chemical probes which have inactive analogs",
    textValidCompound: "The compound has inactive analogs",
    textInvalidCompound: "The compound has not inactive analogs",
    imageValid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/INACTIVE-ANALOG-ON.png",
    imageInvalid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/INACTIVE-ANALOG-OFF.png"
  },
  is_pains: {
    textValid: "The target has chemical probes which are not a Pan-Assay Interfering Compound (PAINS)",
    textInvalid: "The target has not chemical probes which are not a Pan-Assay Interfering Compound (PAINS)",
    textValidCompound: "The compound is not a Pan-Assay Interfering Compound (PAINS)",
    textInvalidCompound: "The compound is a Pan-Assay Interfering Compound (PAINS)",
    imageValid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/NON-PAINS-GREEN.png",
    imageInvalid: "https://cansar.icr.ac.uk/" + "shared/resources/images/chemprobes/PAINS-GREY-RED.png"
  }
};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(495)

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(548),
  /* scopeId */
  "data-v-010256d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(558),
  /* scopeId */
  "data-v-4bafa386",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Documentation_v1_SFig5_v3.ddc1440.jpg";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Documentation_v1_SFig6_v2.ed583d1.jpg";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Documentation_v1_SFig7_v2.1c6b87b.jpg";

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Documentation_v1_SFig8_v4.70aeb1c.jpg";

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ExampleOfHowToUseTheResource_v5.7f0b06f.png";

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/PIK3CB_Snapshot.5af0c12.png";

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s5.26a1d62.png";

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(565),
  /* scopeId */
  "data-v-90cef3a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)
__webpack_require__(504)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(557),
  /* scopeId */
  "data-v-4116554e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)
__webpack_require__(496)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  "data-v-019027c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(556),
  /* scopeId */
  "data-v-360c8701",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  "data-v-f7d78012",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  "data-v-02b40f77",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  "data-v-513fc978",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  "data-v-1e6fad0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  "data-v-664547cd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  "data-v-6c354d23",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)
__webpack_require__(512)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  "data-v-9f348706",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  "data-v-0d5145c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  "data-v-5e7cd93d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(560),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "bottom": "0 !important"
    }
  }, [_c('v-layout', {
    staticClass: "white footer-md",
    attrs: {
      "hidden-md-and-down": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(200)
    }
  }), _c('br')]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Powered by:")]), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "src": __webpack_require__(202)
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": __webpack_require__(203)
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "src": __webpack_require__(201)
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": __webpack_require__(205)
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "white footer-sm",
    attrs: {
      "hidden-lg-and-up": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "110%"
    },
    attrs: {
      "src": __webpack_require__(200)
    }
  }), _c('br')]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("Powered by:")]), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": __webpack_require__(202)
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": __webpack_require__(203)
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": __webpack_require__(201)
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": __webpack_require__(205)
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.loading) ? _c('prb-loading') : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout text-xs-center",
    staticStyle: {
      "min-height": "70vh"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-5 white",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "title white"
  }, [_c('b', [_c('v-icon', {
    staticStyle: {
      "margin-bottom": "3px",
      "margin-right": "3px"
    }
  }, [_vm._v("error_outline")]), _vm._v("\n              Error: Data not found")], 1)])])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target_layout__content elevation-1"
  }, [(_vm.titleName.length) ? _c('v-flex', {
    staticClass: "target__layout pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "target-top__layout__summary-title"
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs10": ""
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.titleName) + " | Probes List")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs2": ""
    }
  }, [(!_vm.loading) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Download full compounds report'
      }),
      expression: "{ html: 'Download full compounds report' }",
      arg: "left"
    }],
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.downloadCsv(_vm.probes)
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("file_download")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.probes) ? _c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "id": "all-table",
      "headers": _vm.tableHeaders,
      "pagination": _vm.pagination,
      "items": _vm.probes,
      "search": _vm.tableSearch
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.header.text) + "\n              ")]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_c('img', {
          attrs: {
            "src": _vm.apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + props.item.id,
            "height": "100"
          }
        })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.nameProbe))]), _vm._v(" "), _c('td', _vm._l((_vm.tableFeatures), function(value, key) {
          return _c('img', {
            key: key,
            attrs: {
              "height": "25",
              "width": "25",
              "src": props.item[key] ? value.imageValid : value.imageInvalid
            }
          })
        })), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.global.toFixed(2)))]), _vm._v(" "), (props.item.chemical_probes_portal_rating.length) ? _c('td', [_c('a', {
          attrs: {
            "href": props.item.chemical_probes_portal_link,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.item.chemical_probes_portal_rating))])]) : _vm._e(), _vm._v(" "), (!props.item.chemical_probes_portal_rating.length) ? _c('td', [_vm._v("-")]) : _vm._e()])]
      }
    }])
  }) : _vm._e()], 1)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "faq__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "faq__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("FAQ")])]), _vm._v(" "), _c('v-card-text', [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("1. What is the difference between Probe Miner and the Chemical Probes Portal?")]), _vm._v(" "), _c('p', [_vm._v("Probe Miner provides computational and statistical assessment of compounds in the medicinal chemistry literature and scores them for their suitability as chemical probes for a certain target. The current version of Probe Miner analysed >1.8 million compounds and provides final scores for approx. 400,000 compounds against 2,220 human targets. The Chemical Probes Portal is an expert-curated resource. As a result, Probe Miner covers a much larger compound and target set, yet does not benefit from the expert annotation for those probes that are in the Chemical Probes Portal. The two resources are highly complementary. For best information to select a suitable probe, we recommend researchers use both resources in conjunction where targets or probes are provided in both.")]), _vm._v(" "), _c('span', {
    staticClass: "body-2"
  }, [_vm._v("2. How often is Probe Miner updated?")]), _vm._v(" "), _c('p', [_vm._v("Currently the underlying data and scores in Probe Miner are updated every three months. We plan more regular updates in future.")]), _vm._v(" "), _c('span', {
    staticClass: "body-2"
  }, [_vm._v("3. Is there a description of the scoring scheme?")]), _vm._v(" "), _c('p', [_vm._v("An article describing the methods and analysis has been uploaded to the preprint server "), _c('a', {
    attrs: {
      "href": "http://www.biorxiv.org",
      "target": "_blank"
    }
  }, [_vm._v("bioRxiv")]), _vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "body-2"
  }, [_vm._v("4. Why can’t I search for a probe?")]), _vm._v(" "), _c('p', [_vm._v("Probe Miner assesses all compounds for suitability as probes against each target. So the same compound may appear for multiple targets and score differently based on the values that relate it to the specific target. The purpose of Probe Miner is to provide an objective view on all possible probes for a particular target.")]), _vm._v(" "), _c('span', {
    staticClass: "body-2"
  }, [_vm._v("5. What does the ‘characterisation’ bar and value mean?")]), _vm._v(" "), _c('p', [_vm._v("A dilemma that we face in objective assessment of probes is the inequality of data available for different targets and compounds. We reward targets and compounds that have extensive experimental characterisations. The characterisation bar and value is a measure derived from the number of active compounds against a query target and the number of off-targets that these compounds have been tested against. The greater the characterisation value, the better.")]), _vm._v(" "), _c('span', {
    staticClass: "body-2"
  }, [_vm._v("6. I know a probe is available for my target but I cannot find it on Probe Miner.")]), _vm._v(" "), _c('p', [_vm._v("Probe Miner relies on data in the public medicinal chemistry resources such as ChEMBL, BindingDB etc. Unfortunately these resources often do not contain data from a few key chemical biology publications and can thus miss key compounds and publications.\n                   Another possible reason is that the data relating to the specific compound may be mis-annotated or mis-curated.\n                   In collaboration with our sister knowledgebase, "), _c('a', {
    attrs: {
      "href": _vm.apiUrl,
      "target": "_blank"
    }
  }, [_vm._v("canSAR")]), _vm._v(",  we are undergoing an extensive curation and including new data.\n                   If you are aware of key missing information or found an error, please let us know on "), _c('a', {
    attrs: {
      "href": "mailto:chemprobes@icr.ac.uk"
    }
  }, [_vm._v("chemprobes@icr.ac.uk")])]), _vm._v(" "), _c('span', {
    staticClass: "body-2"
  }, [_vm._v("7. My probe has published data that Probe Miner says doesn’t exist.")]), _vm._v(" "), _c('p', [_vm._v("Probe Miner relies on data in the public medicinal chemistry resources such as ChEMBL, BindingDB etc. Unfortunately these resources often do not contain data from a few key chemical biology publications and can thus miss key compounds and publications.\n                   Another possible reason is that the data relating to the specific compound may be mis-annotated or mis-curated.\n                   In collaboration with our sister knowledgebase, "), _c('a', {
    attrs: {
      "href": _vm.apiUrl,
      "target": "_blank"
    }
  }, [_vm._v("canSAR")]), _vm._v(",  we are undergoing an extensive curation and including new data.\n                   If you are aware of key missing information or found an error, please let us know on "), _c('a', {
    attrs: {
      "href": "mailto:chemprobes@icr.ac.uk"
    }
  }, [_vm._v("chemprobes@icr.ac.uk")])])])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "target-probes__layout__content",
    staticStyle: {},
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pb-0 pt-3",
    staticStyle: {
      "border-bottom": "2px solid #455A64",
      "background-color": "rgba(0,0,0,.02)"
    },
    attrs: {
      "lg12": "",
      "xs12": ""
    }
  }, [_c('h4', [_vm._v("Scores")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "md5": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "550px",
      "padding-top": "15px"
    },
    attrs: {
      "id": "container"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "rgba(27, 73, 101, 1)",
      "border-radius": "5px",
      "width": "20px",
      "height": "20px"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "pl-2"
  }, [_c('span', [_vm._v("Also in chemicalprobes.org")])])])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "md7": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('button', {
    staticClass: "prev"
  }, [_c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_left")])], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center elevation-0 pa-0",
    attrs: {
      "xs8": ""
    }
  }, [(_vm.counter < _vm.sorted20.length) ? _c('v-progress-linear', {
    attrs: {
      "color-front": "teal lighten-1",
      "color-back": "blue-grey",
      "height": "15"
    },
    model: {
      value: (_vm.counterPrc),
      callback: function($$v) {
        _vm.counterPrc = $$v
      },
      expression: "counterPrc"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.counter < _vm.sorted20.length) ? _c('div', {
    staticStyle: {
      "width": "100",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.counter) + " / " + _vm._s(_vm.sorted20.length))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "siema white",
    class: {
      withOpacity: !_vm.doneloading, withoutOpacity: _vm.doneloading
    }
  }, _vm._l((_vm.sorted20), function(m, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-2",
      staticStyle: {
        "border": "1px solid rgba(0,0,0,.1)"
      },
      attrs: {
        "hover": "",
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "teal lighten-2 white--text"
    }, [_c('h3', {
      staticClass: "headline mb-0 white--text"
    }, [_vm._v(_vm._s(m.namec))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "teal darken-1 white--text",
      nativeOn: {
        "click": function($event) {
          _vm.redirectToCompound(m.idc)
        }
      }
    }, [_c('v-icon', {
      staticClass: "white--text"
    }, [_vm._v("navigate_next")]), _vm._v("SHOW MORE\n              ")], 1)], 1), _vm._v(" "), (m['chemical_probes_portal']) ? _c('v-card-title', {
      staticClass: "teal lighten-2 white--text",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "width": "100%"
      },
      attrs: {
        "target": "_blank",
        "href": 'http://www.chemicalprobes.org/' + m.chemical_probes_portal.name
      }
    }, [_c('v-card', {
      staticClass: "teal darken-1 white--text",
      staticStyle: {
        "padding": "10px 10px 2px 10px"
      },
      attrs: {
        "row": "",
        "wrap": "",
        "hover": "",
        "align-center": ""
      }
    }, [_c('img', {
      attrs: {
        "height": "40",
        "src": "http://www.chemicalprobes.org/sites/all/themes/zurb_foundation/images/cp-img/chemical-probes-logo@2x.png"
      }
    }), _vm._v(" "), _c('v-flex', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "xs12": ""
      }
    }, [_c('star-rating', {
      staticStyle: {
        "margin": "0 auto",
        "width": "88px !important"
      },
      attrs: {
        "max-rating": 4,
        "increment": 0.01,
        "rating": Math.round(parseFloat(m['chemical_probes_portal']['rating_cell'])),
        "star-size": 20,
        "show-rating": false,
        "read-only": true,
        "inactive-color": "black",
        "active-color": "#ffffff"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "white--text"
    }, [_vm._v("Go to The Chemical Probes Portal page for this compound")])])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0",
      on: {
        "click": function($event) {
          _vm.redirectToCompound(m.idc)
        }
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-center teal darken-1 white--text pa-3",
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("Compound")]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center teal darken-2 white--text pa-3",
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("\n                  Values\n                  "), _c('v-icon', {
      staticClass: "white--text",
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "id": "radar-tooltip",
        "dark": ""
      }
    }, [_vm._v("info")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none",
        "text-align": "left"
      },
      attrs: {
        "id": "radar-details"
      }
    }, [_c('table', {
      staticStyle: {
        "text-align": "left !important"
      }
    }, [_c('tr', [_c('td', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v("PAINS")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1: The compound is not predicted to be a Pan-Assay Interference Compound.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0: The compound is predicted to be a Pan-Assay Interference Compound")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v("CELL POTENCY")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1: The compound is active below 10 uM in at least one cell line.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0: The compound is no active below 10 uM in any cell line")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v("SAR")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1: The compound has active analogs")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0: We do not identify analogs of the compound")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v("INACTIVE ANALOGS")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1: The compound has inactive analogs")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0: We do not identify inactive analogs of the compound")])])]), _vm._v(" "), _c('p', [_vm._v("POTENCY AND SELECTIVITY are continues measures of potency and selectivity from 0 (no selectivity) to 1. ")]), _vm._v(" "), _c('p', [_vm._v("Please see methods for details.")])])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right pa-2",
      attrs: {
        "xs11": "",
        "md10": "",
        "lg10": ""
      }
    }), _vm._v(" "), (!m['is_selectivity']) ? _c('v-flex', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:left",
        value: ({
          html: 'Chemical Tool less tha 10-fold selective'
        }),
        expression: "{ html: 'Chemical Tool less tha 10-fold selective' }",
        arg: "left"
      }],
      staticClass: "text-xs-right pa-2",
      attrs: {
        "xs1": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('v-icon', {
      staticClass: "red--text pr-2",
      staticStyle: {
        "font-size": "35px"
      }
    }, [_vm._v("report_problem")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [_c('div', [_c('img', {
      staticClass: "image-carousel",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + m.idc
      }
    })])]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "target-probes__layout__content__spider__layout"
    }, [_c('div', {
      staticStyle: {
        "height": "160px",
        "width": "100%",
        "margin": "0 auto"
      },
      attrs: {
        "id": 'spider-' + index
      }
    })])])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('table', {
      staticClass: "card-table"
    }, [_c('tr', [_c('td', {
      staticClass: "carousel-table-title"
    }, [_vm._v("Global Score")]), _vm._v(" "), _c('td', {
      staticClass: "carousel-table-value"
    }, [_vm._v(_vm._s(Math.round(m.global * 100) / 100))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "carousel-table-title"
    }, [_vm._v("Rank")]), _vm._v(" "), _c('td', {
      staticClass: "carousel-table-value"
    }, [_vm._v(_vm._s(m.global_rank_text))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "carousel-table-title"
    }, [_vm._v("Molecular Weight")]), _vm._v(" "), _c('td', {
      staticClass: "carousel-table-value"
    }, [_vm._v(_vm._s(m.molecular_weight))])])])])], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('button', {
    staticClass: "next"
  }, [_c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border-bottom": "2px solid #455A64",
      "background-color": "rgba(0,0,0,.02)"
    },
    attrs: {
      "lg12": "",
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "pl-3 pb-0 pt-3"
  }, [_vm._v("Distribution")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "pt-3",
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "distribution-chart"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "padding": "0"
    }
  }, [_c('tr', {
    staticStyle: {
      "padding": "0"
    }
  }, _vm._l((_vm.features), function(value, key) {
    return _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ({
          html: _vm.compound[key] ? value.textValidCompound : value.textInvalidCompound
        }),
        expression: "{ html: compound[key] ? value.textValidCompound : value.textInvalidCompound }",
        arg: "top"
      }],
      key: key,
      style: ({
        'text-align': 'center',
        cursor: 'pointer'
      })
    }, [_c('img', {
      staticStyle: {
        "width": "30%",
        "max-width": "50px",
        "padding": "10px 0 0 0"
      },
      attrs: {
        "src": _vm.compound[key] ? value.imageValid : value.imageInvalid
      }
    })])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.features), function(value, key) {
    return _c('td', {
      key: key,
      style: ({
        'text-align': 'center',
        color: 'gray',
        background: _vm.compound[key] ? '#C8E6C9' : '#FFCDD2',
        'border-bottom': _vm.compound[key] ? '5px solid #66BB6A' : '5px solid #EF5350'
      })
    })
  }))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "limitations__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "limitations__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("Limitations")])]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "body-1"
  }, [_vm._v("\n                  Probe Miner uses data obtained from the canSAR knowledgebase "), _c('a', {
    attrs: {
      "href": _vm.apiUrl,
      "target": "_blank"
    }
  }, [_vm._v("(" + _vm._s(_vm.apiUrl) + ")")]), _vm._v(" – that integrates the public medicinal chemistry databases ChEMBL and BindingDB – and an algorithm to objectively assess all the available ligands for a given target and prioritise them as potential chemical probes based on six chemical probe scores, namely: Target Potency Score, Selectivity Score, Cell Potency Score, SAR Score, Inactive Analogs Score and PAINS Score. These six scores are integrated in a Global Score using different weights that can be customised by the user. It is important to stress that Probe Miner is not exempt from limitations, particularly due to the underlying medicinal chemistry data that it uses. It is very important to understand the limitations of Probe Miner before using it. The main limitations are:\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("1. Data incompleteness")])]), _vm._v(" "), _c('p', {
    staticClass: "body-1"
  }, [_vm._v("\n                  Public medicinal chemistry databases do not cover all the available literature. Therefore, although public medicinal chemistry databases cover a large proportion of bioactive small molecules, there is always the risk that a chemical probe is published in a journal that is not covered by public databases and, accordingly, the probe is missing in Probe Miner. Moreover, it is also possible that the probe is present in Probe Miner but key information is missing from public medicinal chemistry databases, thus affecting the ranking of the probe. To mitigate this issue, we have an ongoing data curation effort in collaboration with our sister knowledgebase canSAR to increase the coverage of key chemical biology literature. However, we strongly recommend users to consult the literature very carefully and to use Probe Miner alongside expert curation approaches such as The Chemical Probes Portal whenever possible.\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("2. Data inaccuracies")])]), _vm._v(" "), _c('p', {
    staticClass: "body-1"
  }, [_vm._v("\n                  To reduce the risk of inaccuracies we use only public medicinal chemistry databases that are highly curated. However, no database is exempt from errors or inaccuracies in data entries. Therefore, it is possible that errors or inaccuracies in the data may affect the ranking of a chemical probe. To correct such errors and inaccuracies, we have an extensive ongoing curation effort in collaboration with our sister knowledgebase, canSAR. If you are aware of key missing information or find an error, please let us know on "), _c('a', {
    attrs: {
      "href": "mailto:chemprobes@icr.ac.uk"
    }
  }, [_vm._v("chemprobes@icr.ac.uk")]), _vm._v(".\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("3. Ranking")])]), _vm._v(" "), _c('p', {
    staticClass: "body-1"
  }, [_vm._v("\n                  In some cases, the first ranked compound in Probe Miner may not necessarily be the best available chemical probe for the target of interest. This often occurs when data incompleteness or inaccuracies occur or when there is a very wide variation in the characterisation of chemical probes for the target of interest. In most of those cases, the top ranking compound can be flagged when it is not selective for the target of interest. We have added a danger icon by the chemical structure in the target synopsis page to help users identify those cases. Accordingly, it is not recommended to select the top ranking compounds in Probe Miner without carefully evaluating all the data available and we strongly recommend to also consult expert-curation resources such as The Chemical Probes Portal.\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("4. PAINS")])]), _vm._v(" "), _c('p', {
    staticClass: "body-1"
  }, [_vm._v("\n                  Pan-assay interference compounds (PAINS) are those that interfere with the detection methods of screening assays and are problematic compounds that have been identified to be widely used in many scientific publications as chemical tools, thus leading to incorrect conclusions (Baell and Walters, 2014). There are several computational methods that can be used to predict PAINS and the presence of other potentially problematic functional groups in biochemical and cell-based chemical tools (Huggins, et al. 2011). However, none of the available computational methods is exempt from limitations, among them a considerable number of false-positives that are not actually PAINS (Huggins, et al. 2011; Capuzzi et al., 2017). Accordingly, the PAINS Score measures whether a compound is predicted to be PAINS-free using the substructure filters proposed by Baell et al. (see Methods) as a pragmatic means to alert users to the potential risk of functionality in the molecule that may cause misleading effects in biochemical or cell-based assays. However, to reduce the impact of false-positives we give this PAINS Score a low weighting in the default Global Score so as to reduce the risk of deprioritising otherwise promising molecules. It is important to highlight that the PAINS Score is a prediction calculated using only one computational method. Thus, we enable researchers to set the weight of the PAINS Score within the overall Global Score altogether according to their expert judgement and the specific assay that they may be using. Moreover, researchers can also remove the PAINS Score from the calculation of the Global Score altogether by setting the weight to 0.\n                ")])]), _vm._v(" "), _c('v-divider')], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.loading) ? _c('prb-loading') : _vm._e(), _vm._v(" "), (_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout text-xs-center",
    staticStyle: {
      "min-height": "70vh"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-5 white",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "title white"
  }, [_c('b', [_c('v-icon', {
    staticStyle: {
      "margin-bottom": "5px",
      "margin-right": "3px"
    }
  }, [_vm._v("error_outline")]), _vm._v("\n              Error: Data not found")], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.compound && _vm.compound2 && !_vm.loading && !_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target_layout__content elevation-1"
  }, [(_vm.nameT.length && _vm.nameC.length) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-title"
  }, [_vm._v("\n                " + _vm._s(_vm.nameT) + " | " + _vm._s(_vm.nameC) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('prb-compound-top', {
    attrs: {
      "compound": _vm.compound,
      "compound2": _vm.compound2
    }
  })], 1)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "loading__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "loading__content elevation-1"
  }, [_c('div', {
    staticClass: "loading__bar pa-5"
  }, [_c('v-progress-circular', {
    staticClass: "blue-grey--text text-xs-center",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "indeterminate": "",
      "width": 2,
      "size": 70
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "contact__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "contact__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                If you have any doubt, suggestion or you have identified any data that you believe is missing or require curation, please let us know ["), _c('a', {
    attrs: {
      "href": "mailto:chemprobes@icr.ac.uk"
    }
  }, [_vm._v("chemprobes@icr.ac.uk")]), _vm._v("] to help us improve this resource for\n                the community.\n              ")]), _vm._v(" "), _c('v-divider')], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.loading) ? _c('prb-loading') : _vm._e(), _vm._v(" "), (_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout text-xs-center",
    staticStyle: {
      "min-height": "70vh"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-5 white",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "title white"
  }, [_c('b', [_c('v-icon', {
    staticStyle: {
      "margin-bottom": "3px",
      "margin-right": "3px"
    }
  }, [_vm._v("error_outline")]), _vm._v("\n              Error: Data not found")], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.sorted20 && _vm.target && !_vm.loading && !_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target_layout__content elevation-1"
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-title"
  }, [_vm._v(_vm._s(_vm.titleName))])]), _vm._v(" "), (_vm.portalList.length || _vm.unmapped.length) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('a', {
    staticClass: "target-top__layout__portal-links",
    attrs: {
      "target": "_blank",
      "href": "http://www.chemicalprobes.org/"
    }
  }, [_c('img', {
    staticClass: "mt-2",
    attrs: {
      "height": "30",
      "src": "http://www.chemicalprobes.org/sites/all/themes/zurb_foundation/images/cp-img/chemical-probes-logo@2x.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col mb-1 mr-2 text-xs-left pa-2"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": 'http://www.chemicalprobes.org/search/site/' + _vm.titleName,
      "target": "_blank"
    }
  }, [(!_vm.portalList.length && _vm.unmapped.length) ? _c('v-btn', {
    staticClass: "white--text",
    staticStyle: {
      "background": "#455A64"
    }
  }, [_vm._v("\n                       " + _vm._s(_vm.unmapped.length) + " additional probes\n                     ")]) : _vm._e(), _vm._v(" "), (_vm.portalList.length && !_vm.unmapped.length) ? _c('v-btn', {
    staticClass: "white--text",
    staticStyle: {
      "background": "#455A64"
    }
  }, [_vm._v("\n                       " + _vm._s(_vm.portalList.length) + " common probes\n                     ")]) : _vm._e(), _vm._v(" "), (_vm.portalList.length && _vm.unmapped.length) ? _c('v-btn', {
    staticClass: "white--text",
    staticStyle: {
      "background": "#455A64"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.portalList.length) + " common probes, " + _vm._s(_vm.unmapped.length) + " additional probes\n                    ")]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), _c('prb-target-top', {
    attrs: {
      "target": _vm.target
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-probes__layout-title"
  }, [_vm._v("\n                  ASSESSED COMPOUNDS (" + _vm._s(Object.keys(_vm.probes.metadata).length) + ")\n                ")])]), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "teal darken-1",
    attrs: {
      "persistent": "",
      "height": "100%"
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs6": ""
    }
  }, [_c('p', {
    staticClass: "title target-probes__layout__content__setting-btn white--text"
  }, [_vm._v("SETTINGS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "flat": "",
      "light": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text",
    attrs: {
      "light": ""
    }
  }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0 pr-3 pl-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.customFiltersFlag ? 'Disable Custom Weights' : 'Enable Custom Weights',
      "dark": ""
    },
    on: {
      "change": _vm.changeEnableWeights
    },
    model: {
      value: (_vm.customFiltersFlag),
      callback: function($$v) {
        _vm.customFiltersFlag = $$v
      },
      expression: "customFiltersFlag"
    }
  })], 1), _vm._v(" "), (_vm.customFiltersFlag) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "body-2 white--text pl-3"
  }, [_vm._v("CUSTOM VALUES WEIGHTS:")]), _vm._v(" "), _c('div', {
    staticClass: "pl-3 pr-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("SELECTIVITY (0 - " + _vm._s(_vm.filtersCustom.selectivity) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.selectivity),
      expression: "filtersCustom.selectivity"
    }],
    staticClass: "range-slider",
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.selectivity)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "selectivity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("TARGET POTENCY (0 - " + _vm._s(_vm.filtersCustom.target_potency) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.target_potency),
      expression: "filtersCustom.target_potency"
    }],
    staticClass: "range-slider",
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.target_potency)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "target_potency", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("CELL POTENCY (0 -  " + _vm._s(_vm.filtersCustom.cell_potency) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.cell_potency),
      expression: "filtersCustom.cell_potency"
    }],
    staticClass: "range-slider",
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.cell_potency)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "cell_potency", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("INACTIVE ANALOGS (0 - " + _vm._s(_vm.filtersCustom.inactive_analogs) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.inactive_analogs),
      expression: "filtersCustom.inactive_analogs"
    }],
    staticClass: "range-slider",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.inactive_analogs)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "inactive_analogs", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("SAR (0 - " + _vm._s(_vm.filtersCustom.sar) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.sar),
      expression: "filtersCustom.sar"
    }],
    staticClass: "range-slider",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.sar)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "sar", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("PAINS (0 - " + _vm._s(_vm.filtersCustom.pains) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.pains),
      expression: "filtersCustom.pains"
    }],
    staticClass: "range-slider",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.pains)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "pains", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "outline": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDefaultWeights($event)
      }
    }
  }, [_vm._v("SET DEFAULT WEIGHTS")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "outline": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeCustom($event)
      }
    }
  }, [_vm._v("APPLY SELECTED WEIGHTS")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "body-2 white--text pt-3 pl-3"
  }, [_vm._v("SORT BY:")]), _vm._v(" "), _c('div', {
    staticClass: "section group pa-1"
  }, _vm._l((_vm.displayValues), function(v) {
    return _c('div', {
      staticClass: "col",
      style: ({
        background: _vm.sort === v.name ? 'white' : null,
        color: _vm.sort === v.name ? 'black' : null
      }),
      on: {
        "click": function($event) {
          _vm.changeSort(v.name)
        }
      }
    }, [_vm._v(_vm._s(v.title))])
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "body-2 white--text pt-3 pl-3"
  }, [_vm._v("DISPLAY VALUE:")]), _vm._v(" "), _c('div', {
    staticClass: "section group pa-1"
  }, _vm._l((_vm.displayValues), function(v) {
    return _c('div', {
      staticClass: "col",
      style: ({
        background: _vm.display === v.name ? 'white' : null,
        color: _vm.display === v.name ? 'black' : null
      }),
      on: {
        "click": function($event) {
          _vm.changeDisplay(v.name);
        }
      }
    }, [_vm._v(_vm._s(v.title))])
  }))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0 ma-1 elevation-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "teal lighten-2 elevation-0 pa-2",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.sorted20.length) + " HIGHEST RATED")]), _vm._v(" "), _c('v-btn', {
    staticClass: "teal darken-1",
    attrs: {
      "fab": "",
      "flat": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey darken-2",
    nativeOn: {
      "click": function($event) {
        _vm.goToAll()
      }
    }
  }, [_vm._v("DISPLAY ALL")])], 1), _vm._v(" "), (_vm.sorted20 && !_vm.loading) ? _c('prb-target-compounds', {
    attrs: {
      "all": Object.keys(_vm.probes.metadata).length,
      "sorted20": _vm.sorted20,
      "settings": {
        sort: _vm.sort,
        display: _vm.display
      },
      "distribution": _vm.distribution
    }
  }) : _vm._e()], 1)], 1)], 1)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "white elevation-0 mb-2"
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "padding-top": "50px"
    }
  }, [(_vm.disable) ? _c('span', {
    staticClass: "logo"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "-6px !important"
    },
    attrs: {
      "src": __webpack_require__(204),
      "height": "31"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#4db6ac"
    }
  }, [_vm._v("Probe Miner")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "13px",
      "padding": "0 0 0 11px"
    }
  }, [_vm._v("Chemical Probes Objective Assessment Resource")])]) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('span', {
    staticClass: "logo"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "-6px !important"
    },
    attrs: {
      "src": __webpack_require__(204),
      "height": "31"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#4db6ac"
    }
  }, [_vm._v("Probe Miner")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "13px",
      "padding": "0 0 0 11px"
    }
  }, [_vm._v("Chemical Probes Objective Assessment Resource")])])]) : _vm._e()], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.disable) ? _c('div', [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Tutorial")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Limitations")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Contact us")])], 1) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('div', {
    staticClass: "menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#455A64",
      "padding-bottom": "2px"
    },
    attrs: {
      "left": ""
    }
  }, [_vm._v("home")]), _vm._v("home")], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/about'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/tutorial'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Tutorial")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/download'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/limitations'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Limitations")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/faq'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("FAQ")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Contact")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "landing-middle__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "landing-middle__layout-form"
  }, [_c('prb-stepper', {
    attrs: {
      "disable": !_vm.terms
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('prb-footer')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    staticStyle: {
      "padding": "14px"
    },
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("poorly characterised")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    style: ({
      border: '3px solid' + _vm.getColorPctHex(_vm.score.substring(0, _vm.score.indexOf('%'))),
      'padding': '0 5px',
      'border-radius': '2px'
    })
  }, [_c('v-progress-linear', {
    attrs: {
      "value": _vm.score.substring(0, _vm.score.indexOf('%')),
      "height": "15",
      "color-front": _vm.getColorPct(_vm.score.substring(0, _vm.score.indexOf('%'))),
      "color-back": "blue-grey"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      color: _vm.getColorPctHex(_vm.score.substring(0, _vm.score.indexOf('%'))),
      'font-weight': 600
    })
  }, [_vm._v(_vm._s(_vm.score))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    staticStyle: {
      "padding-top": "14px"
    },
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("well characterised")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "padding": "0"
    }
  }, [_c('tr', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.features), function(value, key) {
    return _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ({
          html: _vm.target[key] ? value.textValid : value.textInvalid
        }),
        expression: "{ html: target[key] ? value.textValid : value.textInvalid }",
        arg: "top"
      }],
      key: key,
      style: ({
        'text-align': 'center',
        cursor: 'pointer'
      })
    }, [_c('img', {
      staticStyle: {
        "width": "30%",
        "max-width": "50px",
        "padding": "10px 0 0 0"
      },
      attrs: {
        "src": _vm.target[key] ? value.imageValid : value.imageInvalid
      }
    })])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "600",
      "padding-right": "5px",
      "max-width": "80px"
    }
  }, [_vm._v("Number of chemical probes")]), _vm._v(" "), _vm._l((_vm.features), function(value, key) {
    return _c('td', {
      key: key,
      style: ({
        'text-align': 'center',
        padding: '10px',
        color: 'gray',
        'font-weight': 600,
        background: _vm.target[key] ? '#C8E6C9' : '#FFCDD2',
        'border-bottom': _vm.target[key] ? '3px solid #66BB6A' : '3px solid #EF5350',
      })
    }, [_vm._v("\n          " + _vm._s(_vm.target[key]) + "\n        ")])
  })], 2)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "target-top__layout"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "target-top__layout-summary-content",
    attrs: {
      "md6": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("\n        FEATURES\n        "), _c('v-icon', {
    staticClass: "features-more",
    attrs: {
      "id": "features-tooltip"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "icons-details"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "600",
      "padding": "0 0 2px 3px"
    }
  }, [_vm._v("When the icon is coloured it has the following meaning:")]), _vm._v(" "), _c('table', {
    staticClass: "icons-table"
  }, _vm._l((_vm.features), function(value, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_c('img', {
      staticStyle: {
        "background": "#ffffff"
      },
      attrs: {
        "src": value.imageValid,
        "height": "15",
        "width": "15"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.textValid))])])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "target-top__layout__summary-content-main"
  }, [_c('prb-features', {
    attrs: {
      "target": _vm.target,
      "features": _vm.features
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "target-top__layout-summary-content",
    attrs: {
      "md6": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("CHARACTERIZATION")]), _vm._v(" "), _c('div', {
    staticClass: "target-top__layout__summary-content-main"
  }, [_c('prb-characterisation', {
    attrs: {
      "score": _vm.target.score
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "tutorial__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "tutorial__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("Tutorial")])]), _vm._v(" "), _c('v-card-text', [_c('span', {
    staticClass: "title"
  }, [_vm._v("Video")]), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "iframe-wrapper"
  }, [_c('iframe', {
    attrs: {
      "src": "https://drive.google.com/file/d/1OOobo7FuDIvLSNLXOfA7bqnjbKpxom-B/preview",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Figures")]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": __webpack_require__(528)
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Flow diagram illustrating the logic for the calculation of the scores, related to STAR Methods.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": __webpack_require__(527)
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Snapshot of the target overview page of the Probe Miner resource for the target PIK3CB.\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "body-1"
  }, [_vm._v("\n                      As it can be observed the first probe according to the pre-defined weights for the Global Score is pictilisib. However, a red warning highlights lack of 10-fold selectivity. This probe is also covered by The Chemical Probes Portal and it is thus highlighted in a differential blue colour, the expert star rating is displayed and appropriate links to The Chemical Probes Portal are provided to facilitate the navigation between the two resources.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": __webpack_require__(526)
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on how to use the resource.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": __webpack_require__(522)
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on the Overview page.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": __webpack_require__(525)
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on the customisation of the Global Score.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": __webpack_require__(523)
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on the Chemical Tool Synopsis page.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": __webpack_require__(524)
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on the Chemical Probes Table page.\n                    ")])])], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "target-top__layout"
  }, [_c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "elevation-1",
    staticStyle: {
      "text-align": "center",
      "padding": "0 5px 5px 20px",
      "margin-bottom": "10px"
    },
    attrs: {
      "md4": "",
      "lg3": "",
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "pa-1",
    attrs: {
      "height": "320",
      "src": _vm.apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + _vm.$route.params.compound
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "md12": "",
      "lg12": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Synonyms")]), _vm._v(" "), _c('div', {
    staticClass: "carousel-table-title"
  }, [(!_vm.compound2.compound_names.length) ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.compound2.compound_names), function(name, i) {
    return (_vm.compound2.compound_names.length) ? _c('span', {
      key: i
    }, [_vm._v("\n                " + _vm._s(name) + "\n                "), (i < _vm.compound2.compound_names.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Molecular Formula")]), _vm._v(" "), _c('div', {
    staticClass: "carousel-table-title"
  }, [_vm._v(_vm._s(_vm.compound2.MOLECULAR_FORMULA))])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-value"
  }, [_vm._v("InChl")])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-title",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_vm._v(_vm._s(_vm.compound2.INCHI))])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Cross References")])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border": "1px solid #4DB6AC"
    }
  }, _vm._l((_vm.compound2.easy_xrefs), function(link, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticClass: "carousel-table-value-2"
    }, [_vm._v(_vm._s(link[0]))]), _vm._v(" "), (!link[1].length) ? _c('td', {
      staticClass: "carousel-table-title-3"
    }, [_vm._v(_vm._s(link[2]))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "carousel-table-title-3",
      staticStyle: {
        "padding": "2px 0 1px 0"
      }
    }, [(link[1].length) ? _c('a', {
      attrs: {
        "href": link[1],
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link[2]))]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border": "1px solid #4DB6AC"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Commercially Available")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title"
  }, [_vm._v(_vm._s(_vm.compound2.commercially_available))])])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "lg12": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "pr-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border": "1px solid #4DB6AC"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "carousel-table-value"
  }, [_c('td', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Properties")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border": "1px solid #4DB6AC"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("Molecular Weight")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.MOLECULAR_WEIGHT < _vm.compound2.property_thresholds.MOLECULAR_WEIGHT ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(parseFloat(_vm.compound2.MOLECULAR_WEIGHT).toFixed(1)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("ALOGP")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.ALOGP < _vm.compound2.property_thresholds.ALOGP ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(parseFloat(_vm.compound2.ALOGP).toFixed(1)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("HBOND DONORS")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.HBOND_DONORS < _vm.compound2.property_thresholds.HBOND_DONORS ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(_vm.compound2.HBOND_DONORS))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("HBOND ACCEPTORS")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.HBOND_ACCEPTORS < _vm.compound2.property_thresholds.HBOND_ACCEPTORS ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(_vm.compound2.HBOND_ACCEPTORS))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("ATOMS")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.ATOMS < _vm.compound2.property_thresholds.ATOMS ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(_vm.compound2.ATOMS))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("CONTAINS TOXICOPHORE")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.CONTAINS_TOXICOPHORE ? 'RED' : 'GREEN'
    })
  }, [_vm._v(_vm._s(_vm.compound2.CONTAINS_TOXICOPHORE ? 'YES' : 'NO'))])])])])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "lg9": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("\n            DATA\n          ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "pa-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "id": "data-table"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Global Score/Rank")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.global_rank_text))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Global Score/Rank (default weights)")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.global_default_weight_rank_text))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Meets minimum quality criteria")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.suitable_probe))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of SAR compounds")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.sar_raw))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of inactive analogs")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.inactive_analogs_raw))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("PAINS Alerts")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.pains_text))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of secondary targets tested")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.no_secondary_targets))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of secondary targets 10-fold selective")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.no_secondary_targets_selective))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Median Target Potency(nM)")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.median_target_potency))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Median Absolute Deviation")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.median_absolute_deviation))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("SIC")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.selectivity_information_content.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of cell lines tested")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.no_celllines))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of cell lines where the tool is active (< 10um)")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.no_celllines_active))])])])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("\n            FEATURES\n            "), _c('v-icon', {
    staticClass: "features-more",
    attrs: {
      "id": "features-tooltip"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "icons-details"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "600",
      "padding": "0 0 2px 3px"
    }
  }, [_vm._v("When the icon is coloured it has the following meaning:")]), _vm._v(" "), _c('table', {
    staticClass: "icons-table"
  }, _vm._l((_vm.features), function(value, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_c('img', {
      staticStyle: {
        "background": "#ffffff"
      },
      attrs: {
        "src": value.imageValid,
        "height": "15",
        "width": "15"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.textValidCompound))])])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "target-top__layout__summary-content-main"
  }, [_c('prb-features', {
    attrs: {
      "compound": _vm.compound.data_compound,
      "features": _vm.features
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "target-top__layout__summary-content-main"
  }, [_c('div', {
    staticStyle: {
      "height": "200px",
      "width": "100%"
    },
    attrs: {
      "id": "spider"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "profile",
    attrs: {
      "xs12": "",
      "lg12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("\n            PROTEIN AFFINITY PROFILE "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'pActivity is the meadian of all pKi, pKd and pIC50 values for each target-compound pair'
      }),
      expression: "{ html: 'pActivity is the meadian of all pKi, pKd and pIC50 values for each target-compound pair' }",
      arg: "top"
    }]
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#455A64",
      "margin-bottom": "5px",
      "cursor": "pointer"
    }
  }, [_vm._v("info")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "bar-profile"
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "about__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "about__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("About")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                The Probe Miner: Objective Assessment of Chemical Probes is a community resource for the evaluation of chemical probes based on large-scale, publicly available, medicinal chemistry data. It is intended to empower researchers to select the best probes\n                based on objective, data driven criteria. This resource provides evaluation of > 1.8m small molecules against for >2,200 human targets and is regularly updated in response to updates in the publicly available medicinal chemistry data.\n                Our continuing data curation efforts will ensure that this resource is continually evolving and improving.\n                "), _c('br'), _c('br'), _vm._v(" If you have identified any data that you believe are missing or require curation, please let us know [\n                "), _c('a', {
    attrs: {
      "href": "mailto:chemprobes@icr.ac.uk"
    }
  }, [_vm._v("chemprobes@icr.ac.uk")]), _vm._v("] to help us improve this resource for the community. Ideally, this resource should be used in conjunction with the complementary Chemical Probes Portal ("), _c('a', {
    attrs: {
      "href": "http://www.chemicalprobes.org",
      "target": "_blank"
    }
  }, [_vm._v("ChemicalProbes.org")]), _vm._v("), which provides expert-driven chemical probe evaluation.\n              ")])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-stepper', {
    staticClass: "white",
    attrs: {
      "alt-labels": ""
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', {
    staticClass: "blue-grey lighten-4 white--text elevation-0"
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.e1 > 1
    }
  }, [_c('span', [_c('v-icon', [_vm._v("search")]), _vm._v("Search targets")], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.e1 > 2
    }
  }, [_c('span', [_c('v-icon', {
    staticClass: "pb-2"
  }, [_vm._v("touch_app")]), _vm._v("Select from list")], 1)])], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1",
      "id": "step-1"
    }
  }, [_c('div', {
    staticClass: "text-md-left"
  }, [(_vm.disable) ? _c('v-text-field', {
    staticClass: "search-form",
    attrs: {
      "disabled": "",
      "name": "input-search",
      "label": "Search",
      "placeholder": "Search targets (example: PARP1, PIK3CA)",
      "append-icon": 'search'
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('v-text-field', {
    staticClass: "search-form input-group--focused",
    attrs: {
      "name": "input-search",
      "min": "1",
      "required": "",
      "placeholder": "Search targets (example: PARP1, PIK3CA)",
      "rules": [_vm.rules.empty()],
      "append-icon": 'search'
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getSearchResults($event)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("*required field")])], 1), _vm._v(" "), (!_vm.search || _vm.search.length > 80) ? _c('v-btn', {
    staticClass: "button-step-1-disabled",
    attrs: {
      "disabled": "",
      "flat": ""
    }
  }, [_vm._v("Evaluate probes for my target")]) : _vm._e(), _vm._v(" "), (_vm.search && _vm.loading && _vm.search.length < 80) ? _c('v-btn', {
    staticClass: "button-step-1-loading",
    attrs: {
      "flat": "",
      "loading": ""
    }
  }, [_vm._v("Evaluate probes for my target")]) : _vm._e(), _vm._v(" "), (_vm.search && !_vm.loading && _vm.search.length < 80) ? _c('v-btn', {
    staticClass: "blue-grey darken-3 button-step-1-normal white--text",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getSearchResults($event)
      }
    }
  }, [_vm._v("Evaluate probes for my target")]) : _vm._e()], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('div', {
    staticClass: "text-md-left"
  }, [_c('v-btn', {
    staticClass: "grey",
    attrs: {
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-left": "-12px"
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n        Back\n      ")], 1), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-1 card-list"
  }, [_c('v-card-title', {
    staticClass: "white--text blue-grey darken-3",
    attrs: {
      "id": "step-2"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Targets found "), _c('span', {
    staticClass: "body-1"
  }, [_vm._v("(" + _vm._s(_vm.searchResultsList.length) + " results)")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "white--text",
    staticStyle: {
      "color": "white !important"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": "",
      "light": ""
    },
    model: {
      value: (_vm.tableSearch),
      callback: function($$v) {
        _vm.tableSearch = $$v
      },
      expression: "tableSearch"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Click on the target to explore all the chemical compounds")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "card-list-text"
  }, [_c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "headers": _vm.tableHeaders,
      "pagination": _vm.pagination,
      "items": _vm.searchResultsList,
      "search": _vm.tableSearch
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [(props.header.text !== 'Features') ? _c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip:bottom",
            value: ({
              html: props.header.tooltip
            }),
            expression: "{ html: props.header.tooltip }",
            arg: "bottom"
          }]
        }, [_vm._v("\n                " + _vm._s(props.header.text) + "\n              ")]) : _vm._e(), _vm._v(" "), (props.header.text === 'Features') ? _c('div', [_vm._v("\n                Features "), _c('v-icon', {
          staticClass: "features-more",
          attrs: {
            "id": "features-tooltip"
          }
        }, [_vm._v("info")])], 1) : _vm._e(), _vm._v(" "), (_vm.tableFeatures) ? _c('div', {
          staticStyle: {
            "display": "none",
            "text-align": "left"
          },
          attrs: {
            "id": "icons-details"
          }
        }, [_c('div', {
          staticClass: "tooltip-bold"
        }, [_vm._v("When the icon is coloured it has the following meaning:")]), _vm._v(" "), _c('table', {
          staticClass: "icons-table"
        }, _vm._l((_vm.tableFeatures), function(value, key) {
          return _c('tr', {
            key: key
          }, [_c('td', [_c('img', {
            staticStyle: {
              "background": "white"
            },
            attrs: {
              "src": value.imageValid,
              "height": "15",
              "width": "15"
            }
          })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.textValid))])])
        }))]) : _vm._e()]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              _vm.redirectToProbes(props.item.uni)
            }
          }
        }, [(_vm.search) ? _c('td', {
          style: ({
            'font-weight': props.item.name.toLowerCase() === _vm.search.toLowerCase() ? '600' : '300'
          })
        }, [_vm._v(_vm._s(props.item.name))]) : _vm._e(), _vm._v(" "), _c('td', _vm._l((_vm.tableFeatures), function(value, key) {
          return _c('div', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: props.item[key] ? value.textValid : value.textInvalid
              }),
              expression: "{ html: props.item[key] ? value.textValid : value.textInvalid }",
              arg: "top"
            }],
            staticStyle: {
              "display": "inline"
            }
          }, [_c('img', {
            key: key,
            attrs: {
              "height": "25",
              "width": "25",
              "src": props.item[key] ? value.imageValid : value.imageInvalid
            }
          })])
        })), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.compounds))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.score))])])]
      }
    }])
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "top": _vm.snackBar.y === 'top'
    },
    model: {
      value: (_vm.snackBar.snackbar),
      callback: function($$v) {
        _vm.$set(_vm.snackBar, "snackbar", $$v)
      },
      expression: "snackBar.snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackBar.text) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "color": "white"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackBar.snackbar = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "700"
    },
    model: {
      value: (_vm.termsDialog),
      callback: function($$v) {
        _vm.termsDialog = $$v
      },
      expression: "termsDialog"
    }
  }, [_c('v-card', {
    staticClass: "grey darken-4 white--text"
  }, [_c('v-card-text', {
    staticClass: "pa-3"
  }, [_vm._v("\n        The Probe Miner: Objective Assessment of Chemical Probes is a community resource for the evaluation of chemical probes based on large-scale, publicly available, medicinal chemistry data. It is intended to empower researchers to select the best probes based on objective, data driven criteria. This resource provides evaluation of > 1.8m small molecules against for >2,200 human targets and is regularly updated in response to updates in the publicly available medicinal chemistry data. Our continuing data curation efforts will ensure that this resource is continually evolving and improving.\n        "), _c('br'), _c('br'), _vm._v("\n        If you have identified any data that you believe are missing or require curation, please let us know\n        ["), _c('a', {
    attrs: {
      "href": "mailto:chemprobes@icr.ac.uk"
    }
  }, [_vm._v("chemprobes@icr.ac.uk")]), _vm._v("] to help us improve this resource for the community.\n        Ideally, this resource should be used in conjunction with the complementary Chemical Probes Portal ("), _c('a', {
    attrs: {
      "href": "http://www.chemicalprobes.org",
      "target": "_blank"
    }
  }, [_vm._v("ChemicalProbes.org")]), _vm._v("), which provides expert-driven chemical probe evaluation.\n        "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pt-2"
  }, [_c('small', [_vm._v("This website uses cookies to store a small amount of information on your computer, as part of the functioning of the site. Cookies used for the operation of the site have already been set.\n            To find out more about the cookies we use and how to delete them, see our "), _c('a', {
    attrs: {
      "href": "http://www.icr.ac.uk/icr/cookies/index.shtml",
      "target": "_blank"
    }
  }, [_vm._v("Cookie")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://www.icr.ac.uk/icr/privacy/index.shtml",
      "target": "_blank"
    }
  }, [_vm._v("\n            Privacy")]), _vm._v(" statements.\n          ")])])]), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-right",
    attrs: {
      "actions": "",
      "dark": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey darken-4 pink--text",
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogRead($event)
      }
    }
  }, [_vm._v("I READ IT")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "download__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "download__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("Download")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "blue-grey lighten-5 mb-2"
  }, [_c('p', [_vm._v(" - All the data calculated from the medicinal chemistry data available in canSAR (Tym et al., 2016; "), _c('a', {
    attrs: {
      "href": _vm.apiUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.apiUrl))]), _vm._v(") can be downloaded from the link below, including a list of all 355,305 human active compounds against all their human targets and their individual as well as global scores.")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm-center"
  }, [_c('a', {
    staticClass: "link-download",
    attrs: {
      "href": "probeminer_datadump.zip",
      "target": "_blank",
      "download": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey white--text"
  }, [_vm._v("DOWNLOAD .TSV FILE")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-sm-center"
  }, [_c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by/4.0/"
    }
  }, [_c('img', {
    staticStyle: {
      "border-width": "0"
    },
    attrs: {
      "alt": "Creative Commons License",
      "src": "https://i.creativecommons.org/l/by/4.0/88x31.png"
    }
  })]), _c('br'), _vm._v("This work is licensed under a "), _c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by/4.0/"
    }
  }, [_vm._v("Creative Commons Attribution 4.0 International License")])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "blue-grey lighten-5"
  }, [_c('p', [_vm._v(" - The Pipeline Pilot 9.5 protocol created by Gary Nugent to calculate the level 1 scaffolds (Langdon et al., 2011)")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm-center"
  }, [_c('a', {
    staticClass: "link-download",
    attrs: {
      "href": "Generate_level1_Scaffolds_from_smiles.xml.zip",
      "target": "_blank",
      "download": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey white--text"
  }, [_vm._v("DOWNLOAD PIPELINE PILOT PROTOCOL")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-sm-center"
  }, [_c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by/4.0/"
    }
  }, [_c('img', {
    staticStyle: {
      "border-width": "0"
    },
    attrs: {
      "alt": "Creative Commons License",
      "src": "https://i.creativecommons.org/l/by/4.0/88x31.png"
    }
  })]), _c('br'), _vm._v("This work is licensed under a "), _c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by/4.0/"
    }
  }, [_vm._v("Creative Commons Attribution 4.0 International License")])])])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(207);
module.exports = __webpack_require__(206);


/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(248),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[575]);


// WEBPACK FOOTER //
// static/js/app.77a58dc199cef2c7e2ed.js